import { precioDeLinea, descuentoDeLinea } from "../../../utils/precioSurtido";
import { totalesNotaActuales, claveRenglon, revisaCuadreNota } from "../../../utils/notaActual";
import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import { ean13ToDataURL } from "../../../utils/ean13";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import * as XLSX from "xlsx";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function ListadoVentas() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_GASTOS_SURTIDOS = process.env.REACT_APP_URL_GASTOS_SURTIDOS;

  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_SEND_MAIL_ATT_DOBLE = process.env.REACT_APP_URL_SEND_MAIL_ATT_DOBLE;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    process.env.REACT_APP_URL_DEPARTAMENTOS_CLIENTES;
  const URL_UPMEDIA = process.env.REACT_APP_URL_UPMEDIA;
  const URL_WHATSAPP = process.env.REACT_APP_URL_WHATSAPP;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_FACTURAS = process.env.REACT_APP_URL_FACTURAS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_TIMBRAR = process.env.REACT_APP_URL_TIMBRAR;
  const URL_SERIES = process.env.REACT_APP_URL_SERIES;
  const URL_DATOS_FACTURACION = process.env.REACT_APP_URL_DATOS_FACTURACION;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_ANTICIPOS = process.env.REACT_APP_URL_ANTICIPOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const BANCO_DEVOLUCION = process.env.REACT_APP_BANCO_DEVOLUCION;
  const BANCO_BONIFICACION = process.env.REACT_APP_BANCO_BONIFICACION;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 91);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  let comp5 = new Date();
  comp5.setDate(comp5.getDate() - 5);
  let evidencia5 = moment(comp5).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  // Objeto seleccionado del Autocomplete del filtro Clientes
  const [valueClienteFiltro, setValueClienteFiltro] = useState(null);
  // Listado completo ya filtrado (sin paginar) — lo consume el Excel
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [selectedEstadoFactura, setSelectedEstadoFactura] = useState("");
  const [selectedEstadoPago, setSelectedEstadoPago] = useState("");
  // Filtro por gastos directos: "" todas / "Con" / "Sin". Se carga una sola
  // vez el conjunto de notas que tienen algún gasto activo en el rango.
  const [selectedGastos, setSelectedGastos] = useState("");
  const [notasConGastos, setNotasConGastos] = useState(new Set());
  // V19 detalle: modal pago directo de una nota
  const [modalPago, setModalPago] = useState(false);
  const [pagoSurtido, setPagoSurtido] = useState(null);
  const [pagoFecha, setPagoFecha] = useState(moment().format("YYYY-MM-DD"));
  const [pagoImporte, setPagoImporte] = useState(0);
  const [pagoBanco, setPagoBanco] = useState("");
  const [pagoFormaPago, setPagoFormaPago] = useState("Transfer");
  const [pagoConcepto, setPagoConcepto] = useState("Abono");
  const [pagoObservaciones, setPagoObservaciones] = useState("NA");
  const [pagoBancos, setPagoBancos] = useState([]);
  const [pagoGuardando, setPagoGuardando] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedActivo, setSelectedActivo] = useState("Si");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  // Se incrementa después de cargar gastos desde Excel para refrescar el filtro
  const [recargaGastos, setRecargaGastos] = useState(0);

  useEffect(() => {
    if (!URL_GASTOS_SURTIDOS || !selectedFechaInicio || !selectedFechaFin) return;
    axios
      .get(`${URL_GASTOS_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const ids = new Set();
        (res.data || []).forEach((g) => {
          const sid = Array.isArray(g.surtidos) ? g.surtidos[0]?._id || g.surtidos[0] : g.surtidos?._id || g.surtidos;
          if (sid) ids.add(String(sid));
        });
        setNotasConGastos(ids);
      })
      .catch(() => setNotasConGastos(new Set()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFechaInicio, selectedFechaFin, URL_GASTOS_SURTIDOS, recargaGastos]);

  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("Si");
  const [subTotalImporteTabla, setSubTotalImporteTabla] = useState(0);
  const [totalImporteTabla, setTotalImporteTabla] = useState(0);
  const [saldoImporteTabla, setSaldoImporteTabla] = useState(0);
  const [totalPiezasTabla, setTotalPiezasTabla] = useState(0);

  // U15: Facturar (estilo Decomax)
  const [modalFacturarPreview, setModalFacturarPreview] = useState(false);
  const toggleFacturarPreview = () => setModalFacturarPreview(!modalFacturarPreview);
  const [facturarSurtido, setFacturarSurtido] = useState(null);
  const [facturarArticulos, setFacturarArticulos] = useState([]);
  const [facturarCliente, setFacturarCliente] = useState(null);
  const [facturarEmpresa, setFacturarEmpresa] = useState(null);
  const [facturarSeries, setFacturarSeries] = useState([]);
  const [facturarSerie, setFacturarSerie] = useState("");
  // W5: PUE/PPD + método pago editables al facturar
  const [facturarMetodoPago, setFacturarMetodoPago] = useState("");
  const [facturarFormaPago, setFacturarFormaPago] = useState("");
  // V16: facturar varios surtidos
  const [selectedSurtidos, setSelectedSurtidos] = useState([]);
  const [facturarTimbres, setFacturarTimbres] = useState(0);
  const [facturando, setFacturando] = useState(false);
  // Datos Facturación del cliente (colección separada). El usuario elige uno del selector
  // y esos datos ganan sobre los del cliente base al mandar la factura.
  const [facturarDatosOpciones, setFacturarDatosOpciones] = useState([]);
  const [facturarDatosSel, setFacturarDatosSel] = useState("");
  // Facturar a "Ventas Mostrador" (público en general) sin datos del cliente
  const [facturarMostrador, setFacturarMostrador] = useState(false);
  // Empresas emisoras seleccionables (la nota puede venir sin idEmpresa)
  const [facturarEmpresasOpciones, setFacturarEmpresasOpciones] = useState([]);
  const [facturarEmpresaSel, setFacturarEmpresaSel] = useState("");

  const [idEvidencia, setidEvidencia] = useState("");
  const [noFactura, setNoFactura] = useState("");
  const [noGuia, setNoGuia] = useState("");
  const [fileFotoEvidencia, setFileFotoEvidencia] = useState();
  const [fileFotoEvidencia2, setFileFotoEvidencia2] = useState();
  const [fotoEvidencia2, setFotoEvidencia2] = useState("No");
  const [fotoEvidencia, setFotoEvidencia] = useState("No");

  const [modalEvidencia, setModalEvidencia] = useState(false);
  const toggleEvidencia = () => setModalEvidencia(!modalEvidencia);
  const [photoEvidencia, setPhotoEvidencia] = useState([]);
  const [modalVerFotoEvidencia, setModalVerFotoEvidencia] = useState(false);
  const toggleVerFotoEvidencia = () =>
    setModalVerFotoEvidencia(!modalVerFotoEvidencia);

  const [enviarMail, setEnviarMail] = useState("");
  const [fechaMail, setFechaMail] = useState("");
  const [idClientesMail, setIdClientesMail] = useState("");
  const [clientesMail, setClientesMail] = useState("");
  const [observacionesMail, setObservacionesMail] = useState("");
  const [numeroMail, setNumeroMail] = useState("");
  const [idPDFOCMail, setIdPDFOCMail] = useState("");
  const [userMail, setUserMail] = useState("");
  const [pedidosMail, setPedidosMail] = useState("");
  const [comisionTDCMail, setComisionTDCMail] = useState("");
  const [comisionFleteMail, setComisionFleteMail] = useState("");
  const [impuestosMail, setImpuestosMail] = useState("");
  const [subTotalMail, setSubTotalMail] = useState("");
  const [ivaMail, setIvaMail] = useState("");
  const [total_generalMail, setTotal_generalMail] = useState("");
  const [calleMail, setCalleMail] = useState("");
  const [numero_extMail, setNumero_extMail] = useState("");
  const [numero_intMail, setNumero_intMail] = useState("");
  const [paisMail, setPaisMail] = useState("");
  const [estadoMail, setEstadoMail] = useState("");
  const [ciudadMail, setCiudadMail] = useState("");
  const [delegacionMail, setDelegacionMail] = useState("");
  const [coloniaMail, setColoniaMail] = useState("");
  const [cpMail, setCpMail] = useState("");
  const [rFCMail, setRFCMail] = useState("");
  const [paqueteriaMail, setPaqueteriaMail] = useState("");
  const [areaMail, setAreaMail] = useState("");
  const [codigoClientesMail, setCodigoClientesMail] = useState("");
  const [vendedorMail, setVendedorMail] = useState("");
  const [telefonoMail, setTelefonoMail] = useState("");
  const [plazoMail, setPlazoMail] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [clienteEdit, setClienteEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [facturaEdit, setFacturaEdit] = useState("");
  const [modalEditNota, setModalEditNota] = useState(false);
  const toggleEditNota = () => setModalEditNota(!modalEditNota);
  const [lineasNota, setLineasNota] = useState([]);

  const [abonadoNota, setAbonadoNota] = useState(0);
  const [totalOriginalNota, setTotalOriginalNota] = useState(0);
  const [impuestosNota, setImpuestosNota] = useState(0);
  const [entregado, setEntregado] = useState("");
  const [surtidoAreaEdit, setSurtidoAreaEdit] = useState("");
  const [surtidoPedidoEdit, setSurtidoPedidoEdit] = useState("");
  const [surtidoClienteEdit, setSurtidoClienteEdit] = useState("");
  const [surtidoFechaEdit, setSurtidoFechaEdit] = useState("");
  const [articulosBD, setArticulosBD] = useState([]);
  const [inventariosBD, setInventariosBD] = useState([]);

  // 0 = sin determinar (se infiere cuando carga el catálogo de artículos)
  const [listaPreciosNota, setListaPreciosNota] = useState(0);

  const precioPorLista = (art, lista) => {
    if (!art) return 0;
    const n = Number(lista);
    const l = (k) => Number(art[k] || 0);
    if (n === 2 && l("lista2") > 0) return l("lista2");
    if (n === 3 && l("lista3") > 0) return l("lista3");
    if (n === 4 && l("lista4") > 0) return l("lista4");
    if (n === 5 && l("lista5") > 0) return l("lista5");
    if (l("lista1") > 0) return l("lista1");
    return Number(art.venta || 0);
  };

  // Cambiar la lista recalcula el precio de CADA línea desde el artículo y,
  // con eso, el total por línea y el de la nota (los totales de la nota se
  // derivan de lineasNota, así que siguen solos).
  function cambiarListaPreciosNota(lista) {
    const n = Number(lista);
    setListaPreciosNota(n);
    setLineasNota((prev) =>
      prev.map((l) => {
        const art = articulosBD.find((a) => String(a._id) === String(l.idArticuloRef || l.idArticulo));
        if (!art) return l;
        const precio = precioPorLista(art, n);
        const cant = Number(l.cantidad) || 0;
        const desc = Number(l.descuento) || 0;
        return { ...l, precio, total: cant * precio * (1 - desc / 100) };
      })
    );
  }

  useEffect(() => {
    // Inferir la lista cuando hay catálogo y la nota no traía una guardada
    if (listaPreciosNota !== 0 || !articulosBD.length || !lineasNota.length) return;
    const primera = lineasNota.find((l) => l.idArticuloRef);
    const art = primera && articulosBD.find((a) => String(a._id) === String(primera.idArticuloRef));
    if (!art) return;
    const eq = (a, b) => Math.abs(Number(a || 0) - Number(b || 0)) < 0.01;
    const p = Number(primera.precio);
    const inferida = eq(art.lista1, p) ? 1 : eq(art.lista2, p) ? 2 : eq(art.lista3, p) ? 3 : eq(art.lista4, p) ? 4 : eq(art.lista5, p) ? 5 : 1;
    setListaPreciosNota(inferida);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articulosBD, lineasNota.length]);
  const [nuevoArtSel, setNuevoArtSel] = useState(null);
  const [nuevoArtCantidad, setNuevoArtCantidad] = useState(1);
  const [nuevoArtPrecio, setNuevoArtPrecio] = useState(0);
  const [nuevoArtDescuento, setNuevoArtDescuento] = useState(0);
  const [surtidosClienteEdit, setSurtidosClienteEdit] = useState([]);
  const [destinoSurtidoId, setDestinoSurtidoId] = useState("");
  const [transferencias, setTransferencias] = useState({}); // {surtidoId: importe}

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_BANCOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setPagoBancos(res.data || []))
      .catch(() => setPagoBancos([]));

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });
      
      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      })
  }, []);

  useMemo(() => {
    axios
      .get(`${URL_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data;
        // Array para pagination
        let arrayTabla = allSurtidos
          .sort((a, b) => (a.idSurtido < b.idSurtido ? 1 : -1))
          .map((a) => {
            const ped = a.pedidos?.[0] || {};
            const cli = a.clientes?.[0] || ped.clientes?.[0] || {};
            const pedCli = ped.clientes?.[0] || {};
            const colab = ped.colaboradores?.[0] || {};
            const user0 = a.user?.[0] || {};
            const dept = (cli.departamentosClientes?.[0]) || (pedCli.departamentosClientes?.[0]) || {};
            const area = a.areas?.[0] || {};
            const fact = a.facturas?.[0] || {};
            return {
              _id: a._id,
              is_active: a.is_active,
              fecha: a.fecha,
              user: (user0.nombre || "") + " " + (user0.apellido || ""),
              idUser: user0._id || "",
              pedidos: ped.idPedido,
              idPedido: ped._id || "",
              clientes: pedCli.nombre_comercial || cli.nombre_comercial || "NA",
              razon_social: pedCli.razon_social || cli.razon_social || "NA",
              saldo: Math.max(0, parseFloat(a.saldo) || 0),
              codigoClientes: pedCli.codigo || cli.codigo || "",
              idClientes: pedCli._id || cli._id || "",
              observaciones: a.observaciones,
              numero: a.idSurtido,
              comisionTDC: ped.comisionTDC || 0,
              comisionFlete: a.flete,
              impuestos: a.impuestos,
              descuento: a.descuento,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              calle: cli.calle || "",
              numero_ext: cli.numero_ext || "",
              numero_int: cli.numero_int || "",
              pais: cli.pais || "",
              estado: cli.estado || "",
              ciudad: cli.ciudad || "",
              delegacion: cli.delegacion || "",
              colonia: cli.colonia || "",
              cp: cli.cp || "",
              paqueteria: cli.paqueteria || "NA",
              RFC: cli.RFC || "",
              area: area.name || "NA",
              vendedor: (colab.nombre || "Sin") + " " + (colab.apellido || "vendedor"),
              idVendedor: colab._id || "",
              emailVendedor: colab.email || "",
              telefono: cli.telefono || "",
              idDepartamento: dept._id || "",
              departamentoName: dept.name || "NA",
              fotoEvidencia: a.fotoEvidencia,
              mail: a.mail,
              plazo: cli.plazo || 0,
              total_cantidad: a.total_cantidad,
              noGuia: a.noGuia,
              noFactura:
                a.facturado === "Si" && fact._id
                  ? `${fact.serie || ""}${fact.folio || ""}`
                  : "NA",
              facturado: a.facturado,
              requiereFactura: a.requiereFactura || "Pendiente",
              estadoFactura:
                a.facturado === "Si"
                  ? "Facturado"
                  : a.requiereFactura === "No"
                    ? "No requiere"
                    : a.requiereFactura === "Si"
                      ? "Pendiente facturar"
                      : "Pendiente",
              factura: a.facturado === "Si" && fact._id ? (fact.serie || "") + (fact.folio || "") : "NA",
              // Para descargar el CFDI (PDF/XML) desde el listado
              idFacturama: fact.idFacturama || "",
              serieFactura: fact.serie || "",
              folioFactura: fact.folio || "",
              empresas: a.empresas?.[0]?.name || "NA",
              idEmpresa: a.empresas?.[0]?._id || "NA",
              flete: a.flete,
              entregado: a.entregado,
              // Pago de comisión en que va la nota (número y fecha)
              ...(() => {
                const com = (a.comisiones || []).filter((c) => c && c.is_active !== "No");
                const pagadas = com.filter((c) => c.pagada === "Si");
                const lista = pagadas.length ? pagadas : com;
                return {
                  comisionPagadaVenta: pagadas.length ? "Si" : "No",
                  comisionTxt: lista.length
                    ? lista.map((c) => `#${c.idComision} · ${fDMA(c.fecha)}`).join(", ")
                    : "",
                };
              })(),
              sinGastoDirecto: a.sinGastoDirecto || "No",
              // Sin el campo = nota de antes de esta función: ya se tomó como mandada
              pdfDescargado: a.pdfDescargado || "Si",
              surtidoDiferente: a.surtidoDiferente || "No",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        // Un usuario vendedor sólo debe ver SUS ventas. Sin esto veía los
        // precios, saldos y clientes de todos los demás vendedores, igual
        // que un administrador. Mismo criterio que ListadoPedidos.
        if (user.vendedor === "Si") {
          dataFinal = dataFinal.filter((v) => v.emailVendedor === user.email);
        }

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user, selectedFechaInicio, selectedFechaFin]);

  // Cambia la fecha de una nota. El back mueve también la fecha de los
  // ArticulosSurtidos, que es la que usa el Reporte de Artículos Vendidos.
  async function cambiarFechaNota(a) {
    // sweetalert2 9.17.4 NO soporta input:"date" (sus tipos son text, email,
    // number, tel, url, textarea, select, radio, checkbox, file y range), así
    // que el campo salía inservible. Se arma el input a mano.
    const { value: nuevaFecha } = await Swal.fire({
      title: `Nota ${a.numero}`,
      html:
        `<p style="margin-bottom:12px">Fecha actual: <b>${a.fecha}</b></p>` +
        `<input id="swalFechaNota" type="date" class="swal2-input" value="${a.fecha}" style="display:block;margin:0 auto">`,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Cambiar fecha",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#28a745",
      preConfirm: () => {
        const v = document.getElementById("swalFechaNota")?.value;
        if (!v) {
          Swal.showValidationMessage("Selecciona una fecha");
          return false;
        }
        return v;
      },
    });
    if (!nuevaFecha || nuevaFecha === a.fecha) return;
    try {
      await axios.patch(
        `${URL_SURTIDOS}Fecha/${a._id}`,
        { fecha: nuevaFecha },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      Swal.fire({
        icon: "success",
        title: "Fecha actualizada",
        text: `${a.fecha} → ${nuevaFecha}`,
        timer: 2000,
        showConfirmButton: false,
      });
      setTimeout(() => window.location.reload(), 1200);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "No se pudo cambiar la fecha",
        text:
          error?.response?.data?.message ||
          "Revisa que tengas permiso de modificar notas",
      });
    }
  }

  // Descarga el CFDI de la factura del surtido (pregunta PDF o XML).
  // Usa los endpoints timbrarObtenerPDF/XML que regresan base64 de Facturama.
  async function descargarFacturaCFDI(a) {
    // sweetalert2 v9 no soporta showDenyButton (tercer botón), así que:
    // confirm = PDF, cancel = XML, y la ✕ / Esc cierran sin descargar.
    const eleccion = await Swal.fire({
      title: `Factura ${a.serieFactura}${a.folioFactura}`,
      text: "¿Qué formato quieres descargar?",
      icon: "question",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "PDF",
      cancelButtonText: "XML",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#28a745",
    });
    const esPDF = eleccion.isConfirmed;
    const esXML = eleccion.dismiss === Swal.DismissReason.cancel;
    if (!esPDF && !esXML) return;
    try {
      const resp = await axios.get(
        `${URL_TIMBRAR}Obtener${esPDF ? "PDF" : "XML"}/${a.idFacturama}`,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      const base64 = resp.data?.respuesta?.Content;
      if (!base64) throw new Error("Facturama no regresó el archivo");
      const byteCharacters = atob(base64);
      const byteNumbers = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([byteNumbers], {
        type: esPDF ? "application/pdf" : "application/xml",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Factura${a.serieFactura}-${a.folioFactura}.${esPDF ? "pdf" : "xml"}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("[descargarFacturaCFDI]", err);
      Swal.fire({
        icon: "error",
        title: "Error al descargar",
        text: err?.response?.data?.message || err?.message || "No se pudo obtener el CFDI",
      });
    }
  }

  function PDFTabla() {
    let subTotalTotal = 0;
    let totalTotal = 0;
    let data1 = comments;
    if (selectedDepartamento) {
      data1 = data1.filter((e) =>
        e.idDepartamento.includes(selectedDepartamento)
      );
    }
    if (search) {
      data1 = data1.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.departamentoName
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.total_general.toString().includes(search)
      );
    }
    let data = data1.map((a) => {
      totalTotal = totalTotal + a.total_general;
      subTotalTotal = subTotalTotal + a.subTotal;
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
        (entregado == 0 || entregado == a.entregado) &&
        (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresa)
      ) {
        if (a.is_active == "Si") {
          return [
            a.numero,
            a.fecha,
            a.clientes,
            // a.departamentoName,
            a.vendedor,
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.subTotal),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.total_general),
            new Intl.NumberFormat("en-US", {
            }).format(a.total_cantidad)
          ];
        } else {
          return [
            a.numero,
            a.fecha,
            a.clientes,
            // a.departamentoName,
            a.vendedor,
            "CANCELADA",
            0,
            0,
          ];
        }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 40, 30);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          // "Departamento",
          "Vendedor",
          "SubTotal",
          "Importe",
          "Piezas",
        ],
      ],
      body: dataPDFLimpia,
      headStyles: {
        fillColor: ["#B02307"],
        lineWidth: 0,
      },
      footStyles: {
        fillColor: ["#B02307"],
      },
      theme: "grid",
      startY: 50,
      foot: [
        [
          // "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(subTotalImporteTabla),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalImporteTabla),
          new Intl.NumberFormat("en-US", {
          }).format(totalPiezasTabla)
        ],
      ],
      showFoot: "lastPage",
    });
    abrePDF(doc, `Notas.pdf`);
  }

  // Exporta TODO el listado que se está viendo (todas las páginas), con las
  // mismas columnas de la tabla. Usa `datosFiltrados`, que ya trae aplicados
  // exactamente los mismos filtros y orden que la vista.
  function excel() {
    const cancelada = (a) => a.is_active === "No";
    const dataExcelLimpia = datosFiltrados.map((a) => ({
      Numero: a.numero,
      Cotizacion: a.pedidos,
      Fecha: a.fecha,
      Empresa: a.empresas,
      Cliente: a.clientes,
      RazonSocial: a.razon_social,
      Almacen: a.area,
      Vendedor: a.vendedor,
      SubTotal: cancelada(a) ? "CANCELADA" : Number(a.subTotal) || 0,
      Total: cancelada(a) ? 0 : Number(a.total_general) || 0,
      Saldo: cancelada(a) ? 0 : Number(a.saldo) || 0,
      Piezas: Number(a.total_cantidad) || 0,
      EstadoFactura: a.estadoFactura,
      Factura: a.factura,
      Comision: a.comisionTxt ? `${a.comisionPagadaVenta === "Si" ? "Pagada" : "Por pagar"} ${a.comisionTxt}` : "Sin pagar",
      Evidencia: a.fotoEvidencia,
    }));

    const columnas = [
      "Numero",
      "Cotizacion",
      "Fecha",
      "Empresa",
      "Cliente",
      "RazonSocial",
      "Almacen",
      "Vendedor",
      "SubTotal",
      "Total",
      "Saldo",
      "Piezas",
      "EstadoFactura",
      "Factura",
      "Comision",
      "Evidencia",
    ];

    var option = {};

    option.fileName = `ListadoNotas-${selectedFechaInicio}-${selectedFechaFin}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNotas",
        sheetFilter: columnas,
        sheetHeader: [
          "Numero",
          "Cotizacion",
          "Fecha",
          "Empresa",
          "Cliente",
          "Razon Social",
          "Almacen",
          "Vendedor",
          "SubTotal",
          "Total",
          "Saldo",
          "Piezas",
          "Estado Factura",
          "Factura",
          "Comisión",
          "Evidencia",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let subTotalTotal = 0;
    let totalTotal = 0;
    let data1 = comments;
    if (selectedDepartamento) {
      data1 = data1.filter((e) =>
        e.idDepartamento.includes(selectedDepartamento)
      );
    }
    if (search) {
      data1 = data1.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.departamentoName
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.total_general.toString().includes(search)
      );
    }
    let data = data1.map((a) => {
      totalTotal = totalTotal + a.total_general;
      subTotalTotal = subTotalTotal + a.subTotal;
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedColaborador == 0 || selectedColaborador == a.idVendedor) &&
        (entregado == 0 || entregado == a.entregado) &&
        (selectedEmpresa == 0 || selectedEmpresa == a.idEmpresa)
      ) {
        if (a.is_active == "Si") {
          return [
            a.numero,
            a.fecha,
            a.clientes,
            a.departamentoName,
            a.vendedor,
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.subTotal),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.total_general),
          ];
        } else {
          return [
            a.numero,
            a.fecha,
            a.clientes,
            a.departamentoName,
            a.vendedor,
            "CANCELADA",
            0,
          ];
        }
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({ compressPdf: true });
    var img = new Image();

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 25, 35, 15);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Departamento",
          "Vendedor",
          "SubTotal",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      headStyles: {
        fillColor: ["#B02307"],
        lineWidth: 0,
      },
      footStyles: {
        fillColor: ["#B02307"],
      },
      theme: "grid",
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(subTotalTotal),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalTotal),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Notas",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

// U17: pregunta las 3 opciones de factura
async function preguntarFactura(venta) {
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
  const { value } = await Swal.fire({
    title: "¿Cómo manejar la factura?",
    input: "radio",
    inputOptions: {
      no: "No requiere factura",
      si: "Si requiere factura (mueve cargos a K)",
      facturar: "Si requiere factura y facturar ahora",
    },
    inputValidator: (v) => !v && "Selecciona una opción",
    showCancelButton: true,
    confirmButtonText: "Aplicar",
  });
  if (!value) return;
  try {
    if (value === "no") {
      await axios.patch(`${URL_SURTIDOS}NoRequiereFactura/${venta._id}`, {}, { headers });
      Swal.fire({ icon: "success", title: "No requiere factura" });
    } else if (value === "si") {
      await axios.patch(`${URL_SURTIDOS}RequiereFactura/${venta._id}`, {}, { headers });
      Swal.fire({ icon: "success", title: "Marcado en K (saldo movido)" });
    } else if (value === "facturar") {
      await axios.patch(`${URL_SURTIDOS}RequiereFactura/${venta._id}`, {}, { headers });
      // luego abre el flujo de facturación
      await previewFacturar(venta);
      return;
    }
    setTimeout(() => window.location.reload(), 800);
  } catch (e) {
    Swal.fire({ icon: "error", title: "Error", text: e.response?.data?.message || e.message });
  }
}

// U15: vista previa de factura (estilo Decomax)
async function previewFacturar(a) {
  try {
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    const [resArts, resCli, resEmp, resTimbres, resSeries, resDatosFac, resEmpresas] = await Promise.all([
      axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${a._id}`, { headers }),
      axios.get(`${URL_CLIENTES}/${a.idClientes}`, { headers }),
      a.idEmpresa && a.idEmpresa !== "NA" ? axios.get(`${URL_EMPRESAS}/${a.idEmpresa}`, { headers }) : Promise.resolve({ data: null }),
      // Timbres disponibles: renglón `serie: "TIMBRES"` en la colección Series
      axios.get(`${URL_SERIES}Timbres`, { headers }).catch(() => ({ data: [] })),
      // Series usables para facturar (F, A, ...): endpoint separado
      axios.get(`${URL_SERIES}Facturacion`, { headers }).catch(() => ({ data: [] })),
      // Datos de facturación del cliente para poblar el selector
      axios
        .get(`${URL_DATOS_FACTURACION}Cliente/${a.idClientes}`, { headers })
        .catch(() => ({ data: [] })),
      // Todas las empresas emisoras (por si la nota no trae idEmpresa)
      axios.get(URL_EMPRESAS, { headers }).catch(() => ({ data: [] })),
    ]);
    setFacturarArticulos(resArts.data || []);
    setFacturarCliente(resCli.data || null);

    const empresasArr = Array.isArray(resEmpresas.data) ? resEmpresas.data : [];
    setFacturarEmpresasOpciones(empresasArr);
    // Prioridad: la empresa poblada en el surtido; si no hay, la que aparece en `name` del surtido; si no, "Ofnoa Parts"; si no, la primera.
    let empresaDefault = resEmp.data || null;
    if (!empresaDefault && empresasArr.length) {
      empresaDefault =
        empresasArr.find(
          (e) =>
            (e.name || "").toLowerCase() ===
            String(a.empresas || "").toLowerCase()
        ) ||
        empresasArr.find((e) => /ofnoa/i.test(e.name || "") || /ofnoa/i.test(e.razonSocial || "")) ||
        empresasArr[0];
    }
    setFacturarEmpresa(empresaDefault);
    setFacturarEmpresaSel(empresaDefault?._id || "");

    const seriesArr = Array.isArray(resSeries.data) ? resSeries.data : [];
    setFacturarSeries(seriesArr);
    const serieF = seriesArr.find((s) => s.serie === "F");
    setFacturarSerie(serieF ? "F" : seriesArr[0]?.serie || "");

    const timbresArr = Array.isArray(resTimbres.data) ? resTimbres.data : [];
    setFacturarTimbres(timbresArr[0]?.folio || 0);

    const datosArr = Array.isArray(resDatosFac.data) ? resDatosFac.data : [];
    setFacturarDatosOpciones(datosArr);
    // Default: si el cliente sólo tiene un juego de datos, autoseleccionalo
    setFacturarDatosSel(datosArr.length === 1 ? datosArr[0]._id : "");
    setFacturarMostrador(false); // arranca siempre desmarcado

    setFacturarSurtido(a);
    // W5: cargar defaults editables de PUE/PPD y forma de pago del cliente
    setFacturarMetodoPago(resCli.data?.metodoPagoSAT || "PPD");
    setFacturarFormaPago(resCli.data?.formaPagoSAT || "99");
    toggleFacturarPreview();
  } catch (err) {
    console.log(err);
    Swal.fire({ icon: "error", title: "Oops...", text: "No se pudo cargar la vista previa de la factura" });
  }
}

// V16: facturar varios surtidos en una sola factura
async function facturarMultiplesSurtidos() {
  if (selectedSurtidos.length < 2) {
    Swal.fire({ icon: "warning", title: "Selecciona al menos 2 surtidos" });
    return;
  }
  const surtidos = comments.filter((c) => selectedSurtidos.includes(c._id));
  const clienteIds = [...new Set(surtidos.map((s) => s.idClientes))];
  if (clienteIds.length > 1) {
    Swal.fire({ icon: "error", title: "Distintos clientes", text: "Solo puedes facturar juntos surtidos del mismo cliente" });
    return;
  }
  const yaFacturados = surtidos.filter((s) => s.facturado === "Si");
  if (yaFacturados.length > 0) {
    Swal.fire({ icon: "error", title: "Ya facturados", text: `${yaFacturados.length} ya están facturados` });
    return;
  }
  const conf = await Swal.fire({
    title: `¿Facturar ${surtidos.length} surtidos en una sola factura?`,
    text: `Cliente: ${surtidos[0].clientes}. Total: $${surtidos.reduce((acc, s) => acc + Number(s.total_general || 0), 0).toFixed(2)}`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Si, facturar",
  });
  if (!conf.isConfirmed) return;
  // Tomar el primer surtido como base, abrir modalFacturarPreview con todos sumados
  const base = surtidos[0];
  const sumSubTotal = surtidos.reduce((acc, s) => acc + Number(s.subTotal || 0), 0);
  const sumIva = surtidos.reduce((acc, s) => acc + Number(s.iva || 0), 0);
  const sumTotal = surtidos.reduce((acc, s) => acc + Number(s.total_general || 0), 0);
  const sumCant = surtidos.reduce((acc, s) => acc + Number(s.total_cantidad || 0), 0);
  const merged = {
    ...base,
    subTotal: sumSubTotal,
    iva: sumIva,
    total_general: sumTotal,
    total_cantidad: sumCant,
    _isMulti: true,
    _idsMulti: surtidos.map((s) => s._id),
  };
  await previewFacturar(merged);
}

function abrirModalPago(surtidoRow) {
  setPagoSurtido(surtidoRow);
  setPagoFecha(moment().format("YYYY-MM-DD"));
  // Saldo del surtido: usar a.saldo si viene, sino total_general - cargosk
  const saldoNota = parseFloat(surtidoRow.saldo) || parseFloat(surtidoRow.total_general) || 0;
  setPagoImporte(saldoNota);
  setPagoBanco("");
  setPagoFormaPago("Transfer");
  setPagoConcepto("Abono");
  setPagoObservaciones("NA");
  setModalPago(true);
}

async function guardarPagoNota() {
  if (!pagoSurtido) return;
  const importe = parseFloat(pagoImporte) || 0;
  if (importe <= 0) {
    Swal.fire({ icon: "warning", title: "Importe inválido", text: "Captura un importe mayor a 0" });
    return;
  }
  if (!pagoBanco) {
    Swal.fire({ icon: "warning", title: "Banco requerido", text: "Selecciona un banco" });
    return;
  }
  // W8: si pagan más del saldo y la nota no requiere factura → crear anticipo con excedente
  const saldoAnt = parseFloat(pagoSurtido.saldo) || parseFloat(pagoSurtido.total_general) || 0;
  let importeAbono = importe;
  let excedente = 0;
  if (importe > saldoAnt && pagoSurtido.requiereFactura !== "Si" && pagoSurtido.facturado !== "Si") {
    excedente = importe - saldoAnt;
    importeAbono = saldoAnt;
  }
  const conf = await Swal.fire({
    title: `¿Aplicar pago de $${importe.toFixed(2)}?`,
    text: excedente > 0
      ? `Abono $${importeAbono.toFixed(2)} a nota ${pagoSurtido.numero} + Anticipo $${excedente.toFixed(2)}`
      : `Nota ${pagoSurtido.numero} — Cliente ${pagoSurtido.clientes}`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, aplicar",
  });
  if (!conf.isConfirmed) return;
  setPagoGuardando(true);
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
  try {
    await axios.post(
      URL_ABONOS,
      {
        fecha: pagoFecha,
        importe: importeAbono,
        clientes: pagoSurtido.idClientes,
        colaboradores: pagoSurtido.idVendedor,
        surtidos: pagoSurtido._id,
        formaPago: pagoFormaPago,
        concepto: pagoConcepto,
        bancos: pagoBanco,
        comisionPagada: "No",
        observaciones: pagoObservaciones,
        codigoAgrupado: uuidv4(),
        editado: "No",
      },
      { headers }
    );
    // Si hay excedente, crear anticipo
    if (excedente > 0) {
      try {
        await axios.post(
          URL_ANTICIPOS,
          {
            fecha: pagoFecha,
            importe: excedente,
            saldo: excedente,
            utilizado: 0,
            clientes: pagoSurtido.idClientes,
            bancos: pagoBanco,
            formaPago: pagoFormaPago,
            observaciones: `Excedente nota ${pagoSurtido.numero}`,
          },
          { headers }
        );
      } catch (errAnt) { console.log("Error anticipo", errAnt); }
    }
    const saldoAnterior = parseFloat(pagoSurtido.saldo) || parseFloat(pagoSurtido.total_general) || 0;
    await axios.patch(
      `${URL_SURTIDOS}/${pagoSurtido._id}`,
      { saldo: saldoAnterior - importeAbono },
      { headers }
    );
    // W6: si la nota está facturada, disparar complemento de pago (CFDI tipo P)
    if (pagoSurtido.esComplemento) {
      try {
        await axios.post(
          `${URL_TIMBRAR}Complemento`,
          {
            surtido: pagoSurtido._id,
            importe: importeAbono,
            fecha: pagoFecha,
            formaPago: pagoFormaPago,
          },
          { headers }
        );
      } catch (errComp) { console.log("Complemento de pago no disponible o falló:", errComp); }
    }
    await axios.post(
      URL_MOVIMIENTOS_BANCOS,
      {
        fecha: pagoFecha,
        importe,
        tipo: "Ingreso",
        bancos: pagoBanco,
        moneda: "MXN",
        tipoCambio: 1,
        observaciones: `Abono nota ${pagoSurtido.numero} cliente ${pagoSurtido.clientes}`,
      },
      { headers }
    ).catch(() => {});
    await axios.post(
      URL_LOGS,
      { tipo: "Pago Nota", detalle: `Pago $${importe} nota ${pagoSurtido.numero}`, user: user.id },
      { headers }
    ).catch(() => {});
    setComments((prev) =>
      prev.map((c) =>
        c._id === pagoSurtido._id
          ? { ...c, saldo: Math.max(0, (parseFloat(c.saldo) || 0) - importeAbono) }
          : c
      )
    );
    setPagoGuardando(false);
    setModalPago(false);
    Swal.fire("Good job!", "Pago aplicado", "success");
  } catch (err) {
    setPagoGuardando(false);
    console.log(err);
    Swal.fire({ icon: "error", title: "Error", text: "No se pudo aplicar el pago" });
  }
}

async function confirmarFacturar() {
  if (!facturarSurtido) return;
  if (facturarTimbres <= 0) {
    Swal.fire({ icon: "error", title: "Sin timbres", text: "No hay timbres disponibles" });
    return;
  }
  if (!facturarSerie) {
    Swal.fire({ icon: "error", title: "Serie", text: "Selecciona una serie" });
    return;
  }
  const confirm = await Swal.fire({
    title: "¿Confirmas facturar esta nota?",
    html: facturarMostrador
      ? `Nota ${facturarSurtido.numero}<br/><b>Se timbrará al RFC genérico XAXX010101000</b>,<br/>a nombre de ${facturarSurtido.clientes}.<br/><small>No sale como factura global, así que no se adjudica a otro mes.</small>`
      : `Nota ${facturarSurtido.numero} — Cliente ${facturarSurtido.clientes}`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, timbrar",
  });
  if (!confirm.isConfirmed) return;

  try {
    setFacturando(true);
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    const surtido = facturarSurtido;
    const clienteBase = facturarCliente || {};
    // Si el usuario eligió un juego de datos de facturación, ese gana sobre el cliente base
    const datosSel = facturarDatosOpciones.find((d) => d._id === facturarDatosSel) || null;
    // Ventas Mostrador: receptor genérico del SAT. El back ya normaliza este
    // RFC (régimen 616, uso S01, PUE, CP del emisor e InformacionGlobal).
    const empresaParaCP =
      facturarEmpresasOpciones.find((e) => e._id === facturarEmpresaSel) ||
      facturarEmpresa ||
      {};
    const cliente = facturarMostrador
      ? {
          ...clienteBase,
          // Se conserva la razón social REAL del cliente a propósito. Poner
          // "PUBLICO EN GENERAL" es justo lo que hace que Facturama exija el
          // nodo InformacionGlobal, y ese nodo adjudica la venta al mes de la
          // fecha de la factura. El RFC sí va genérico.
          RFC: "XAXX010101000",
          regFiscal: 616,
          cp: empresaParaCP.expeditionPlace || empresaParaCP.cp || clienteBase.cp,
          usoCFDI: "S01",
          formaPagoSAT: "01",
          metodoPagoSAT: "PUE",
          condicionesPagoSAT: "NA",
        }
      : datosSel
      ? {
          ...clienteBase,
          razon_social: datosSel.razon_social,
          RFC: datosSel.RFC,
          regFiscal: datosSel.regFiscal,
          cp: datosSel.cp,
          usoCFDI: datosSel.usoCFDI,
          formaPagoSAT: datosSel.formaPagoSAT,
          metodoPagoSAT: datosSel.metodoPagoSAT,
          condicionesPagoSAT: datosSel.condicionesPagoSAT,
        }
      : clienteBase;
    const empresaSel =
      facturarEmpresasOpciones.find((e) => e._id === facturarEmpresaSel) || null;
    const empresa = empresaSel || facturarEmpresa || {};

    // En Ventas Mostrador no se piden datos fiscales del cliente
    if (!facturarMostrador && facturarDatosOpciones.length > 0 && !facturarDatosSel) {
      setFacturando(false);
      Swal.fire({ icon: "warning", title: "Datos de Facturación", text: "Selecciona un juego de datos de facturación del cliente" });
      return;
    }
    if (!cliente.razon_social || !cliente.RFC || !cliente.usoCFDI) {
      setFacturando(false);
      Swal.fire({ icon: "error", title: "Datos fiscales incompletos", text: "Los datos de facturación no tienen Razón Social, RFC o Uso CFDI" });
      return;
    }
    if (!empresa.razonSocial || !empresa.rfc || empresa.razonSocial === "NA" || empresa.rfc === "NA") {
      setFacturando(false);
      Swal.fire({ icon: "error", title: "Empresa no configurada", text: "La empresa emisora no tiene Razón Social o RFC" });
      return;
    }

    // W5: usar valores editables del modal (override del cliente)
    const metodoFinal = facturarMetodoPago || cliente.metodoPagoSAT;
    let formaPagoFinal = facturarFormaPago || cliente.formaPagoSAT;
    if (metodoFinal === "PPD") formaPagoFinal = "99";

    // Factura a RFC genérico (XAXX010101000) en PPD: no se emite como factura
    // global. Ver la nota en TimbrarController: el nodo InformacionGlobal
    // obliga a PUE y no existe en el complemento de pago.
    const esPublicoGeneral =
      String(cliente.RFC || "").toUpperCase().trim() === "XAXX010101000";
    if (esPublicoGeneral && metodoFinal === "PPD") {
      const ok = await Swal.fire({
        title: "RFC genérico en PPD",
        icon: "warning",
        html:
          `Se timbrará al RFC genérico <b>XAXX010101000</b> en <b>PPD</b>, ` +
          `con forma de pago <b>99 Por definir</b>.<br><br>` +
          `<b>No saldrá como factura global</b> (sin Año/Mes/Periodicidad): ` +
          `ese bloque obliga a PUE. Se usará la razón social del cliente.<br><br>` +
          `Al cobrarla habrá que emitir su complemento de pago.<br><br>` +
          `<small>Si el SAT rechaza esta combinación, Facturama devolverá el ` +
          `motivo exacto y la factura no se timbrará.</small>`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Timbrar en PPD",
        cancelButtonText: "Cancelar",
      });
      if (!ok.isConfirmed) {
        setFacturando(false);
        return;
      }
    }

    const descuentoPct = Number(surtido.descuento || 0);
    const descuentoMonto = (Number(surtido.subTotal || 0) * descuentoPct) / 100;

    const facturaResp = await axios.post(
      URL_FACTURAS,
      {
        fecha: surtido.fecha,
        observaciones: "NA",
        totalCantidad: surtido.total_cantidad,
        subTotal: parseFloat(surtido.subTotal).toFixed(2),
        iva: parseFloat(surtido.iva).toFixed(2),
        total: parseFloat(surtido.total_general).toFixed(2),
        abonos: 0,
        saldo: parseFloat(surtido.total_general).toFixed(2),
        pagado: "No",
        descuentoPorcentaje1: descuentoPct.toFixed(2),
        descuentoNumero1: descuentoMonto.toFixed(2),
        descuentoConcepto1: "NA",
        descuentoPorcentaje2: 0,
        descuentoNumero2: 0,
        descuentoConcepto2: "NA",
        empresas: empresa._id || surtido.idEmpresa,
        clientes: surtido.idClientes,
        colaboradores: surtido.idVendedor,
        timbre: "No",
        currency: "MXN",
        cfdiType: "I",
        serie: facturarSerie,
        expeditionPlace: empresa.cp,
        rfcEmpresa: empresa.rfc,
        nombreEmpresa: empresa.razonSocial,
        regFiscalEmpresa: empresa.regimenFiscal,
        condicionesPagoSATCliente: cliente.condicionesPagoSAT,
        formaPagoSATCliente: formaPagoFinal,
        metodoPagoSATCliente: metodoFinal,
        rfcCliente: cliente.RFC,
        nombreCliente: cliente.razon_social,
        usoCFDICliente: cliente.usoCFDI,
        regFiscalCliente: Number(cliente.regFiscal || 0),
        cpCliente: cliente.cp,
        numeroPagos: 0,
      },
      { headers }
    );
    const facturaId = facturaResp.data._id;

    // V16: si es factura multi-surtido, patchear todos los IDs.
    // Solo dejamos el vínculo `facturas: facturaId`; el `facturado:"Si"` lo aplica
    // TimbrarController AL ÉXITO del timbre (updateMany por facturaId).
    // Si Facturama devuelve error el surtido se queda con facturado:"No".
    const idsAPatchear = surtido._isMulti ? surtido._idsMulti : [surtido._id];
    await Promise.all(
      idsAPatchear.map((id) =>
        axios.patch(
          `${URL_SURTIDOS}Factura/${id}`,
          { facturas: facturaId },
          { headers }
        )
      )
    );

    await axios.post(`${URL_TIMBRAR}Factura`, { facturas: facturaId }, { headers });

    await axios.post(
      URL_LOGS,
      { tipo: "Crear Factura", detalle: `Factura desde Nota ${surtido.numero}`, user: user.id },
      { headers }
    );

    setComments((prev) =>
      prev.map((c) =>
        idsAPatchear.includes(c._id)
          ? {
              ...c,
              facturado: "Si",
              factura: `${facturarSerie || ""}${(facturarSeries.find((s) => s.serie === facturarSerie)?.folio || 0) + 1}`,
              estadoFactura: "Facturado",
            }
          : c
      )
    );
    setSelectedSurtidos([]);
    setFacturando(false);
    setModalFacturarPreview(false);
    Swal.fire("Good job!", "Factura timbrada", "success");
  } catch (error) {
    console.log(error);
    setFacturando(false);
    const data = error?.response?.data;
    const msg = data?.message || error.message;
    Swal.fire({ icon: "error", title: "Error al facturar", text: msg });
  }
}

// U18: regresar K → T (antes de facturar)
async function regresarKaT(venta) {
  const conf = await Swal.fire({
    title: "Regresar a T",
    text: "Se devolverá el saldo de K a T",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Sí, regresar",
  });
  if (!conf.isConfirmed) return;
  try {
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    await axios.patch(`${URL_SURTIDOS}RegresarK/${venta._id}`, {}, { headers });
    Swal.fire({ icon: "success", title: "Saldo regresado a T" });
    setTimeout(() => window.location.reload(), 800);
  } catch (e) {
    Swal.fire({ icon: "error", title: "Error", text: e.response?.data?.message || e.message });
  }
}

function cancelarNota(idNota, numero) {
  Swal.fire({
    title: "¿Estás seguro?",
    text: "¡Se cancelará la Nota!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Sí, Cancelar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .get(`${URL_SURTIDOS}Cancel/${idNota}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(() => {
          // 🔹 Registrar log de cancelación
          axios.post(
            URL_LOGS,
            {
              tipo: "Cancelar Nota",
              detalle: `Nota ${numero} cancelada`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );

          Swal.fire("Good job!", "Nota cancelada con éxito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Algo salió mal!",
            footer: `${error.response?.data || "Error desconocido"}`,
          });
          console.log(error);
        });
    }
  });
}


  // C9: PDF enfocado en peso (pesoPieza + pesoCaja de Articulos)
  async function PDFPeso(idSurtido, numero, clienteName, fecha, area) {
    try {
      const res = await axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idSurtido}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const filas = (res.data || [])
        .filter((a) => a?.articulos?.[0])
        .map((a) => {
          const art = a.articulos[0];
          const cantidad = Number(a.cantidad || 0);
          const pesoPieza = Number(art.pesoPieza || 0);
          const pesoCaja = Number(art.pesoCaja || 0);
          const pxc = Number(art.piezasPorCaja || 1) || 1;
          const cajas = cantidad / pxc;
          const pesoTotal = cantidad * pesoPieza;
          return {
            idArticulo: art._id,
            codigo: art.codigo || "",
            nombre: art.nombre || "",
            cantidad,
            cajas,
            pesoPieza,
            pesoCaja,
            pesoTotal,
          };
        });
      // Agrupar por artículo
      const grupos = {};
      for (const f of filas) {
        const id = String(f.idArticulo);
        grupos[id] = grupos[id] || { ...f, cantidad: 0, cajas: 0, pesoTotal: 0 };
        grupos[id].cantidad += f.cantidad;
        grupos[id].cajas += f.cajas;
        grupos[id].pesoTotal += f.pesoTotal;
      }
      const rows = Object.values(grupos)
        .sort((a, b) => (a.codigo || "").localeCompare(b.codigo || ""))
        .map((g) => [
          g.codigo,
          g.nombre,
          new Intl.NumberFormat("en-US").format(g.cantidad),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(g.cajas),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoPieza) + " kg",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoCaja) + " kg",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(g.pesoTotal) + " kg",
        ]);
      const totalPiezas = Object.values(grupos).reduce((t, g) => t + g.cantidad, 0);
      const totalCajas = Object.values(grupos).reduce((t, g) => t + g.cajas, 0);
      const totalPeso = Object.values(grupos).reduce((t, g) => t + g.pesoTotal, 0);

      const doc = new jsPDF("portrait", "mm", "a4", true);
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      doc.addImage(img, "png", 15, 8, 33, 20);
      doc.setFontSize(12);
      doc.text(`Nota de Salida por Peso`, 105, 20, { align: "center" });
      doc.setFontSize(9);
      doc.text(`Cliente: ${clienteName || ""}`, 15, 34);
      doc.text(`Remisión: ${numero || ""}   Fecha: ${fecha || ""}   Área: ${area || ""}`, 15, 40);

      doc.autoTable({
        head: [["Código", "Descripción", "Cantidad", "Cajas", "Peso Pieza", "Peso Caja", "Peso Total"]],
        body: rows,
        startY: 45,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [176, 35, 7], textColor: 255, halign: "center", fontSize: 8 },
        columnStyles: {
          2: { halign: "right" },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
        },
        foot: [[
          "", "Totales",
          new Intl.NumberFormat("en-US").format(totalPiezas),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(totalCajas),
          "", "",
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 3 }).format(totalPeso) + " kg",
        ]],
        footStyles: { fillColor: [176, 35, 7], textColor: 255, fontSize: 8 },
      });
      abrePDF(doc, `Peso-${numero || idSurtido}.pdf`);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo generar el PDF de peso" });
    }
  }

  async function PDFBarrasSurtido(surtidoId, numero, clienteName) {
    try {
      const res = await axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${surtidoId}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      const items = res.data || [];
      if (items.length === 0) {
        Swal.fire({ icon: "info", title: "Surtido sin articulos" });
        return;
      }
      const doc = new jsPDF({ compressPdf: true });
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text(`Surtido #${numero} - Codigos de Barras`, 14, 18);
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(`Cliente: ${clienteName || ""}`, 14, 25);

      const body = items.map((a) => {
        const art = a.articulos?.[0] || {};
        const cant = Number(a.cantidad || 0);
        const ppc = Number(art.piezasPorCaja || 0);
        const cajas = ppc > 0 ? (cant / ppc).toFixed(2) : "-";
        const ean = String(art.EAN || "").replace(/[^0-9]/g, "");
        const dataUrl = ean
          ? ean13ToDataURL(ean, { moduleWidth: 2, height: 50, textSize: 14 })
          : null;
        return {
          articulo: `${art.codigo || ""} ${art.nombre || ""}`,
          cantidad: cant,
          cajas,
          ean,
          dataUrl,
        };
      });

      doc.autoTable({
        head: [["Articulo", "Cantidad", "Cajas", "Codigo Barras"]],
        body: body.map((b) => [b.articulo, b.cantidad, b.cajas, ""]),
        startY: 32,
        bodyStyles: { rowHeight: 16, valign: "middle" },
        styles: { fontSize: 9, cellPadding: 1.5 },
        headStyles: {
          fillColor: "#911c04",
          textColor: "#ffffff",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 90 },
          1: { halign: "center", cellWidth: 22 },
          2: { halign: "center", cellWidth: 22 },
          3: { cellWidth: 45, halign: "center" },
        },
        didDrawCell: function (data) {
          if (data.column.index === 3 && data.cell.section === "body") {
            const row = body[data.row.index];
            if (row?.dataUrl) {
              try {
                const imgW = data.cell.width - 4;
                const imgH = data.cell.height - 4;
                const x = data.cell.x + 2;
                const y = data.cell.y + 2;
                doc.addImage(row.dataUrl, "PNG", x, y, imgW, imgH);
              } catch (e) {
                console.log("EAN13 error", e);
              }
            } else if (row?.ean) {
              doc.setFontSize(8);
              doc.text(
                `EAN invalido: ${row.ean}`,
                data.cell.x + data.cell.width / 2,
                data.cell.y + data.cell.height / 2,
                { align: "center", baseline: "middle" }
              );
            } else {
              doc.setFontSize(8);
              doc.text(
                "Sin EAN",
                data.cell.x + data.cell.width / 2,
                data.cell.y + data.cell.height / 2,
                { align: "center", baseline: "middle" }
              );
            }
          }
        },
      });

      abrePDF(doc, `Surtido-${numero}-CodigosBarras.pdf`);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo generar el PDF de codigos de barras",
      });
    }
  }

  // ---- Gastos directos de la venta ----
  // Son los que se le pueden atribuir a UNA nota (flete pagado aparte,
  // maniobras, empaque especial). El Reporte de Utilidades los descuenta
  // sobre esa nota, a diferencia de los gastos generales que se prorratean.
  const [modalGastos, setModalGastos] = useState(false);
  const [notaGastos, setNotaGastos] = useState(null);
  const [gastosNota, setGastosNota] = useState([]);
  const [gastoConcepto, setGastoConcepto] = useState("");
  const [gastoImporte, setGastoImporte] = useState("");
  const [gastoFecha, setGastoFecha] = useState(moment().format("YYYY-MM-DD"));

  const authHeaders = () => ({
    headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
  });

  // ── Carga de gastos de envío desde Excel, por número de pedido ──
  const [modalGastosExcel, setModalGastosExcel] = useState(false);
  const [gxFilas, setGxFilas] = useState([]); // renglones leídos del archivo
  const [gxResultado, setGxResultado] = useState(null); // respuesta del back
  const [gxArchivo, setGxArchivo] = useState("");
  const [gxTrabajando, setGxTrabajando] = useState(false);

  // Encabezado normalizado: minúsculas, sin acentos ni espacios/símbolos
  const normaliza = (t) =>
    String(t || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const ALIAS_GX = {
    pedido: ["pedido", "nopedido", "numpedido", "numeropedido", "idpedido", "pedidono", "folio", "foliopedido"],
    importe: ["importe", "costo", "costoenvio", "costodeenvio", "monto", "total", "envio", "flete", "costoflete"],
    concepto: ["concepto", "descripcion", "paqueteria", "servicio"],
    referencia: ["guia", "noguia", "numeroguia", "referencia", "rastreo", "tracking"],
  };

  function descargarPlantillaGastos() {
    new ExportJsonExcel({
      fileName: "PlantillaGastosEnvio",
      datas: [
        {
          sheetData: [{ Pedido: 553, Importe: 350.5, Concepto: "Envío Estafeta", Guia: "1234567890" }],
          sheetName: "Gastos",
          sheetFilter: ["Pedido", "Importe", "Concepto", "Guia"],
          sheetHeader: ["Pedido", "Importe", "Concepto", "Guia"],
        },
      ],
    }).saveExcel();
  }

  async function mandarGastosExcel(filas, aplicar) {
    setGxTrabajando(true);
    try {
      const { data } = await axios.post(`${URL_GASTOS_SURTIDOS}Excel`, { filas, aplicar }, authHeaders());
      setGxResultado(data);
      return data;
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "No se pudo procesar",
        text: err?.response?.data?.message || err.message,
      });
      return null;
    } finally {
      setGxTrabajando(false);
    }
  }

  function leerExcelGastos(file) {
    if (!file) return;
    setGxArchivo(file.name);
    setGxResultado(null);
    const reader = new FileReader();
    reader.onload = async (ev) => {
      try {
        const wb = XLSX.read(new Uint8Array(ev.target.result), { type: "array" });
        const crudas = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: "" });
        if (!crudas.length) {
          Swal.fire({ icon: "warning", title: "El archivo está vacío" });
          return;
        }
        // Qué columna del archivo es cada campo
        const cols = Object.keys(crudas[0]);
        const mapa = {};
        for (const [campo, alias] of Object.entries(ALIAS_GX)) {
          mapa[campo] = cols.find((c) => alias.includes(normaliza(c)));
        }
        if (!mapa.pedido || !mapa.importe) {
          Swal.fire({
            icon: "error",
            title: "No encuentro las columnas",
            html:
              "El archivo necesita al menos una columna <b>Pedido</b> y una <b>Importe</b> (o Costo / Costo envío).<br/><br/>" +
              `Columnas encontradas: ${cols.join(", ")}`,
          });
          return;
        }
        const filas = crudas
          .map((r) => ({
            pedido: r[mapa.pedido],
            importe: r[mapa.importe],
            concepto: mapa.concepto ? r[mapa.concepto] : "",
            referencia: mapa.referencia ? r[mapa.referencia] : "",
          }))
          // Renglones totalmente vacíos (el Excel suele traer algunos al final)
          .filter((r) => String(r.pedido).trim() !== "" || String(r.importe).trim() !== "");
        setGxFilas(filas);
        await mandarGastosExcel(filas, false);
      } catch (err) {
        console.log("[gastos excel]", err);
        Swal.fire({ icon: "error", title: "No se pudo leer el archivo", text: err.message });
      }
    };
    reader.readAsArrayBuffer(file);
  }

  async function aplicarGastosExcel() {
    const n = gxResultado?.resumen?.ok || 0;
    const r = await Swal.fire({
      title: `¿Cargar ${n} gasto${n === 1 ? "" : "s"}?`,
      text: `Total ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
        gxResultado?.resumen?.importe || 0
      )}. Los renglones con error o ya cargados se omiten.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, cargar",
      cancelButtonText: "Cancelar",
    });
    if (!r.isConfirmed) return;
    const data = await mandarGastosExcel(gxFilas, true);
    if (!data) return;
    setRecargaGastos((x) => x + 1);
    axios
      .post(
        URL_LOGS,
        {
          tipo: "Carga Gastos Excel",
          detalle: `${gxArchivo}: ${data.resumen.cargados} cargados, ${data.resumen.omitidos} omitidos, ${data.resumen.errores} con error`,
          user: user.id,
        },
        authHeaders()
      )
      .catch(() => {});
    Swal.fire({
      icon: "success",
      title: "Gastos cargados",
      text: `${data.resumen.cargados} cargados · ${data.resumen.omitidos} omitidos · ${data.resumen.errores} con error`,
    });
  }

  async function abrirGastos(a) {
    setNotaGastos(a);
    setGastosNota([]);
    setGastoConcepto("");
    setGastoImporte("");
    setGastoFecha(a.fecha || moment().format("YYYY-MM-DD"));
    setModalGastos(true);
    try {
      const res = await axios.get(`${URL_GASTOS_SURTIDOS}/${a._id}`, authHeaders());
      setGastosNota(res.data || []);
    } catch (error) {
      console.log("gastos de la nota:", error);
    }
  }

  async function guardarGasto() {
    const imp = Number(gastoImporte) || 0;
    if (!gastoConcepto.trim()) {
      return Swal.fire({ icon: "error", title: "Falta el concepto" });
    }
    if (imp <= 0) {
      return Swal.fire({ icon: "error", title: "El importe debe ser mayor a 0" });
    }
    try {
      await axios.post(
        URL_GASTOS_SURTIDOS,
        {
          fecha: gastoFecha,
          surtidos: notaGastos._id,
          // Sólo se mandan si tienen valor: una referencia vacía no pasa el
          // cast a ObjectId y tumbaba el guardado.
          ...(notaGastos.idClientes ? { clientes: notaGastos.idClientes } : {}),
          concepto: gastoConcepto.trim(),
          importe: imp,
          ...(user.id ? { user: user.id } : {}),
        },
        authHeaders()
      );
      setGastoConcepto("");
      setGastoImporte("");
      const res = await axios.get(`${URL_GASTOS_SURTIDOS}/${notaGastos._id}`, authHeaders());
      setGastosNota(res.data || []);
    } catch (error) {
      console.log("guardar gasto:", error);
      Swal.fire({
        icon: "error",
        title: "No se pudo guardar el gasto",
        // El motivo real viene del servidor; sin esto el aviso no dice nada
        // y hay que ir a buscarlo a la consola.
        text: error?.response?.data?.message || "",
      });
    }
  }

  function cancelarGasto(id) {
    Swal.fire({
      title: "¿Cancelar este gasto?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, cancelar",
      cancelButtonText: "No",
      confirmButtonColor: "#dc3545",
    }).then(async (r) => {
      if (!r.isConfirmed) return;
      try {
        await axios.patch(`${URL_GASTOS_SURTIDOS}Cancel/${id}`, {}, authHeaders());
        const res = await axios.get(`${URL_GASTOS_SURTIDOS}/${notaGastos._id}`, authHeaders());
        setGastosNota(res.data || []);
      } catch (error) {
        console.log("cancelar gasto:", error);
      }
    });
  }

  const totalGastosNota = gastosNota.reduce((t, g) => t + Number(g.importe || 0), 0);

  // Visor de la nota: se guarda la URL del PDF en memoria para mostrarlo en
  // un modal, en vez de bajarlo al disco cada vez que se quiere revisar.
  const [notaPreview, setNotaPreview] = useState(null);
  const cerrarPreview = () => {
    if (notaPreview?.url) URL.revokeObjectURL(notaPreview.url);
    setNotaPreview(null);
  };

  // Marcas de la nota que no tocan importes (back: surtidosMarcas)
  async function marcaNota(a, cambios) {
    try {
      await axios.patch(`${URL_SURTIDOS}Marcas/${a._id}`, cambios, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      setComments((prev) => prev.map((c) => (c._id === a._id ? { ...c, ...cambios } : c)));
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "No se pudo guardar", text: err?.response?.data?.message || err.message });
    }
  }

  async function cambiaSinGasto(a) {
    const marcar = a.sinGastoDirecto !== "Si";
    const r = await Swal.fire({
      icon: "question",
      title: `Nota ${a.numero}`,
      text: marcar
        ? "¿Marcar que esta nota no lleva gasto directo? Deja de salir en el filtro \"Sin gastos\"."
        : "¿Quitar la marca? Vuelve a salir en el filtro \"Sin gastos\".",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "Cancelar",
    });
    if (!r.isConfirmed) return;
    await marcaNota(a, { sinGastoDirecto: marcar ? "Si" : "No" });
  }

  async function PDFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    vendedor,
    telefono,
    descuento,
    conImagenes = true,
    soloVer = false,
  ) {
    try {
      const response = await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
        let allArticulosSurtido = response.data;
        // Totales de la nota como están HOY en el servidor, no los de la tabla
        // cargada en pantalla (pueden ser de antes de una edición hecha en
        // otra pestaña u otra computadora). Si falla, se usan los de la tabla.
        try {
          ({ subTotal, iva, total_general, descuento } = await totalesNotaActuales(idPDFOC));
        } catch (e) {
          console.log("[totales nota]", e);
        }
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            if (!a?.articulos?.[0]) return null;
            const art = a.articulos[0];
            const inv = a.inventarios?.[0];
            const ap = a.articulosPedido?.[0];
            return {
              id: inv?._id || art._id,
              codigo: art.codigo,
              articulos: art.nombre,
              cantidad: a.cantidad,
              idArticulo: art._id,
              // Precio y descuento SELLADOS en la nota (los que se cobraron). El
              // del pedido puede haber cambiado después de surtir; y si no había
              // pedido se usaba el COSTO como precio.
              precio: precioDeLinea(a),
              descuento: descuentoDeLinea(a),
              cajas: a.cantidad / (art.piezasPorCaja || 1),
              fotoArticulo: art.foto,
              foto: ""
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        revisaCuadreNota(dataFinal, subTotal, numero);

        let agrupado = dataFinal.reduce(function (groups, item) {
          // Mismo artículo a distinto precio/descuento = renglones distintos
          const val = claveRenglon(item);
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
            cajas: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].cajas += item.cajas;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          groups[val].descuento = item.descuento || 0;
          groups[val].codigo = item.codigo;
          groups[val].foto = item.foto;
          groups[val].fotoArticulo = item.fotoArticulo;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);

        let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);

        let TC = agrupadoValues.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let totalParcial = 0;

        // Si el usuario eligió sin imágenes, saltamos las requests a Cloudinary.
        if (conImagenes) {
          const imagePromises = agrupadoValues.map(async (z) => {
            return (async () => {
              if (z.fotoArticulo === "Si") {
                try {
                  const imgResponse = await axios.get(`${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`, {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  });
                  z.foto = imgResponse.data.secure_url || process.env.PUBLIC_URL + "sinImagen.png";
                } catch (error) {
                  console.error("Error al cargar imagen:", error);
                  z.foto = process.env.PUBLIC_URL + "sinImagen.png";
                }
              } else {
                z.foto = process.env.PUBLIC_URL + "sinImagen.png";
              }
            })();
          });
          await Promise.all(imagePromises);
        }
       

        setTimeout(() => {

        // si alguna línea tiene descuento, agregar columna DESC %
        const hayDescuentos = agrupadoValues.some((a) => parseFloat(a.descuento || 0) > 0);

        const data = agrupadoValues.map((a) => {
          const descPct = parseFloat(a.descuento || 0);
          totalParcial = a.cantidad * a.precio * (1 - descPct / 100);
          const cols = [
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.codigo,
            a.articulos,
            new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
              a.cantidad
            ) + " / " + new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.cajas) + " Cajas",
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.precio),
          ];
          if (hayDescuentos) {
            cols.push(descPct > 0 ? `${descPct.toFixed(2)}%` : "-");
          }
          cols.push(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalParcial)
          );
          // Foto en la columna 0 solo si el usuario la pidió
          if (conImagenes) cols.unshift(a.foto);
          return cols;
        });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });

        const colFoto = { fontSize: .000001, textColor: [255, 255, 255], cellWidth: 20, };
        const colBase = hayDescuentos
          ? [
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"], halign: "right" },
              { fontSize: 9, textColor: ["#000000"], halign: "center" },
              { fontSize: 9, textColor: ["#000000"], halign: "right" },
            ]
          : [
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"], halign: "right" },
              { fontSize: 9, textColor: ["#000000"], halign: "right" },
            ];
        const columnStyles = conImagenes ? [colFoto, ...colBase] : colBase;
        const doc = new jsPDF({ compressPdf: true });
        var img = new Image();
        var img2 = new Image();
        const backgroundColor = ["#d1d2d4"];
        const backgroundColorBoxLightGray = ["#e6e7e9"];
        const backgroundColorBoxBlack = ["#231f20"];
        const backgroundColorBoxPurple = ["#B02307"];
        const margins = { left: 5, right: 5 };

        img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img, "png", 15, 5, 33, 20);

        // img.src = process.env.PUBLIC_URL + "marcas.png";
        // doc.addImage(img, "png", 9, 28, 192, 10);
        // doc.setFontSize(10);

        doc.setFillColor(...backgroundColor);
        doc.rect(5, 40, 200, 6, "F");
        doc.setTextColor("#000000");
        doc.setFontSize(10);
        doc.text(`Tel: 55 1234 5678`, 8, 44);

        doc.setTextColor("#000000");

        doc.text(`Cliente: ${codigoClientes} - ${clientes} Telefono: ${telefono}`, 8, 52);
        doc.text(`Remisión: ${numero}`, 100, 44);
        doc.text(`Cotización: ${pedidos}`, 170, 44);
        doc.text(`Direccion: ${calle} ${numero_ext} ${numero_int} ${estado} ${ciudad} ${cp}`, 8, 57);
        doc.text(`Vendedor: ${vendedor}`, 8, 62);

        // doc.setTextColor("#B02307");
        // doc.setFontSize(12);
        // doc.setFont("helvetica", "bold");
        // doc.text(`macuro.mx`, 175, 44);
        // doc.setTextColor("#000000");

        doc.setFontSize(14);
        doc.setFillColor(...backgroundColorBoxBlack);
        doc.rect(100, 4, 105, 22, "F");
        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(74, 4, 25, 22, "F");
        doc.setTextColor("#ffffff");
        doc.text(`NOTA DE SALIDA`, 125, 12);
        doc.setFont("helvetica", "normal");
        doc.text(`SALIDA BODEGA ${area}`, 125, 17);
        doc.text(`México, D. F. a ${fecha}`, 125, 22);


        const headBase = hayDescuentos
          ? ["CANTIDAD", "MODELO", "DESCRIPCION", "CANTIDAD", "PRECIO UNITARIO", "DESC %", "IMPORTE"]
          : ["CANTIDAD", "MODELO", "DESCRIPCION", "CANTIDAD", "PRECIO UNITARIO", "IMPORTE"];
        doc.autoTable({
          head: [conImagenes ? ["", ...headBase] : headBase],
          body: dataPDFLimpia,
          bodyStyles:{
            rowHeight : conImagenes ? 22 : 8,
            valign: "middle"
          },
          styles: {
            fontSize: 10,
            // overflow: "linebreak",
            // columnWidth: "wrap",
            // // font: 'arial',
            // overflowColumns: "linebreak",
          },
          headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0,
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          columnStyles: columnStyles,
          theme: "grid",
          margin: { left: 5, right: 5 },
          startY: 65,

          showFoot: "lastPage",

        didDrawCell: function(data) {
          if (conImagenes && data.column.index === 0 && data.cell.section === 'body') {
             var td = data.cell.raw;
             var img = td
            //  var dim = data.cell.height - data.cell.padding('vertical');
             var textPos = data.cell;
             doc.addImage(img, textPos.x,  textPos.y, 20, 20);
          }
        },
        });

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(5, doc.autoTable.previous.finalY + 1, 36, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFontSize(8);
        doc.text(`TOTAL DE ARTICULOS`, 7, doc.autoTable.previous.finalY + 5);
        doc.setTextColor("#000000");
        // doc.text(
        //   `________________________________________________________________________________________________________________________________`,
        //   5,
        //   doc.autoTable.previous.finalY + 30
        // );

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setFont("helvetica", "normal");
        doc.rect(40, doc.autoTable.previous.finalY + 1, 40, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US").format(TM) + " Piezas",
          42,
          doc.autoTable.previous.finalY + 5
        );
        if (doc.autoTable.previous.finalY + 40> doc.internal.pageSize.height - 10) {
          doc.addPage();
          doc.autoTable.previous.finalY = 10
       }
        doc.setFontSize(7.5);
        doc.text(
          `1. Esta es una venta en firme y no se acepta ningún tipo de descuento o devolución sin consentimiento previo.`,
          5,
          doc.autoTable.previous.finalY + 11
        );
        doc.text(
          `2. La mercancía viaja por cuenta y riesgo del cliente, no somos responsables por faltante.`,
          5,
          doc.autoTable.previous.finalY + 14
        );
        doc.text(
          `3. El pago de la mercancía debe realizarse en tiempo y forma pactados a la cuenta proporcionada por nosotros.`,
          5,
          doc.autoTable.previous.finalY + 17
        );

        var nota =
          "Debo(emos)  y pagare(mos)  incondicionalmente por  este  pagare a la orden  de MACURO en esta plaza,  el día estipulado en  este documento,  la cantidad estipulada  en este  documento,  valor recibido a  mi entera satisfacción, este pagare causará intereses a razón de 2% mensual a partir de la fecha de vencimiento, hasta su total liquidación, pagadero conjuntamente con el principal. Este pagare se rige en los términos de ley general de títulos y operaciones de crédito.";
        var lines = doc.splitTextToSize(nota, 129);
        doc.text(5, doc.autoTable.previous.finalY + 26, lines);

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 1, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`SUBTOTAL $`, 153, doc.autoTable.previous.finalY + 5);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 1, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(subTotal.toFixed(2)),
          183,
          doc.autoTable.previous.finalY + 5
        );

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 8, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`FLETE $`, 153, doc.autoTable.previous.finalY + 12);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 8, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(comisionFlete + comisionTDC),
          183,
          doc.autoTable.previous.finalY + 12
        );

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 15, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`IMPUESTO $`, 153, doc.autoTable.previous.finalY + 19);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 15, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(iva),
          183,
          doc.autoTable.previous.finalY + 19
        );

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 22, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`DESCUENTO ${descuento}%`, 153, doc.autoTable.previous.finalY + 26);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 22, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            maximumFractionDigits: 2,
          }).format(((subTotal * descuento)/ 100).toFixed(2)),
          183,
          doc.autoTable.previous.finalY + 26
        );

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 29, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`TOTAL $`, 153, doc.autoTable.previous.finalY + 34);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 29, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(total_general.toFixed(2)),
          183,
          doc.autoTable.previous.finalY + 34
        );

        var lines = doc.splitTextToSize(`Observaciones: ${observaciones}`, 40);
        doc.text(145, doc.autoTable.previous.finalY + 40, lines);

        doc.setFont("helvetica", "bold");
        doc.text(
          `Nombre Completo:__________________________________________________________________________  Firma:______________________________`,
          5,
          doc.autoTable.previous.finalY + 57
        );

        doc.setFont("helvetica", "normal");
        doc.setFontSize(6);
        doc.text(
          `ESTE DOCUMENTO NO REPRESENTA UN COMPROBANTE FISCAL`,
          67,
          doc.autoTable.previous.finalY + 67
        );

        if (soloVer) {
          // Se muestra en un modal; el usuario decide si lo descarga
          setNotaPreview({ numero, url: doc.output("bloburl") });
        } else {
          abrePDF(doc, `Nota-${numero}.pdf`);
        }
        //   }
        // });
        // });
    }, 1000);
      
    } catch (err) {
      console.error("Error al obtener datos del surtido:", err);
    }
  }

   async function excelOC(id, numero) {
    await axios
    .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = allArticulosPedido
          .map((a) => {
            return {
               id: a.inventarios[0]._id,
              codigo: a.articulos[0].codigo,
              articulo: a.articulos[0].nombre,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: precioDeLinea(a),
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const dataExportExcel = Object.values(arrayTabla);
        const dataExcelLimpia = dataExportExcel.filter(function (el) {
          return el != null;
        });

        var option = {};

        option.fileName = `Venta ${numero}`;

        option.datas = [
          {
            sheetData: dataExcelLimpia,
            sheetFilter: [
              "codigo",
              "articulo",
              "cantidad",
              "precio",
            ],
            sheetHeader: [
               "codigo",
              "articulo",
              "cantidad",
              "precio",
            ],
          },
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Cotizacion", field: "pedidos", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    // { name: "Empresa", field: "empresas", sortable: true },
    { name: "Sel", field: "sel", sortable: false },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Razon Social", field: "razon_social", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    // { name: "Departamento", field: "departamentoName", sortable: true },
    { name: "SubTotal", field: "subTotal", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Piezas", field: "total_cantidad", sortable: true },
    { name: "Estado Factura", field: "estadoFactura", sortable: true },
    { name: "Factura", field: "factura", sortable: true },
    { name: "Comisión", field: "comisionTxt", sortable: true },
    // Acciones en dos columnas: lo fiscal/cobranza por un lado, y lo que
    // edita o imprime la nota por el otro. Juntas eran 15 botones seguidos.
    { name: "Facturas / Pagos", field: "accionesFact", sortable: false },
    { name: "Edición / PDF", field: "accionesEdit", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;
    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
        comment.empresas.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.factura.toLowerCase().includes(search.toLowerCase()) ||
          comment.departamentoName
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.subTotal.toString().includes(search) ||
          comment.total_general.toString().includes(search)
      );
    }
    if (selectedEstadoFactura) {
      computedComments = computedComments.filter((e) => e.estadoFactura === selectedEstadoFactura);
    }
    if (selectedGastos) {
      // "Sin gastos" es lo que falta por capturar: no incluye las marcadas
      // como que no llevan gasto directo.
      computedComments = computedComments.filter((e) =>
        selectedGastos === "Con"
          ? notasConGastos.has(String(e._id))
          : selectedGastos === "NoLleva"
          ? e.sinGastoDirecto === "Si"
          : !notasConGastos.has(String(e._id)) && e.sinGastoDirecto !== "Si"
      );
    }
    if (selectedEstadoPago) {
      computedComments = computedComments.filter((e) => {
        const saldo = parseFloat(e.saldo) || 0;
        if (selectedEstadoPago === "Liquidada") return saldo <= 0;
        if (selectedEstadoPago === "Pendiente") return saldo > 0;
        return true;
      });
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        String(e.idClientes || "").includes(selectedCliente)
      );
    }
    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        String(e.idEmpresa || "").includes(selectedEmpresa)
      );
    }
    if (selectedColaborador) {
      computedComments = computedComments.filter((e) =>
        String(e.idVendedor || "").includes(selectedColaborador)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        String(e.idUser || "").includes(selectedUser)
      );
    }
    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        String(e.is_active || "").includes(selectedActivo)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedDepartamento) {
      computedComments = computedComments.filter((e) =>
        e.idDepartamento.includes(selectedDepartamento)
      );
    }
   if (entregado) {
      computedComments = computedComments.filter((e) =>
        e.entregado.includes(entregado)
      );
    }
    // Considerar como activos los que NO están explícitamente cancelados
    let activos = computedComments.filter((e) => e.is_active !== "No");

    // U16: usar fallback 0 para evitar NaN en la suma
    let TC = activos.reduce((t, c) => t + (Number(c.total_cantidad) || 0), 0);
    setTotalPiezasTabla(TC);

    let TS = activos.reduce((t, c) => t + (Number(c.subTotal) || 0), 0);
    setSubTotalImporteTabla(TS);

    let TT = activos.reduce((t, c) => t + (Number(c.total_general) || 0), 0);
    setTotalImporteTabla(TT);

    let TSaldo = activos.reduce((t, c) => t + (Number(c.saldo) || 0), 0);
    setSaldoImporteTabla(TSaldo);

    setTotalItems(computedComments.length);

    //Sorting comments
    const camposNumericos = ["pedidos", "numero", "total_cantidad", "subTotal", "total_general", "saldo"];
    if (
      sorting.field &&
      !camposNumericos.includes(sorting.field)
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * String(a[sorting.field] || "").localeCompare(String(b[sorting.field] || ""))
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      camposNumericos.includes(sorting.field)
    ) {
      computedComments = computedComments.sort((a, b) =>
        (parseFloat(a[sorting.field]) || 0) > (parseFloat(b[sorting.field]) || 0) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      camposNumericos.includes(sorting.field)
    ) {
      computedComments = computedComments.sort((a, b) =>
        (parseFloat(a[sorting.field]) || 0) < (parseFloat(b[sorting.field]) || 0) ? 1 : -1
      );
    }

    // Listado COMPLETO ya filtrado y ordenado (sin paginar). El Excel lo usa
    // para exportar exactamente lo mismo que se ve en pantalla, no solo la
    // página actual ni un subconjunto con filtros distintos.
    setDatosFiltrados(computedComments);

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedEmpresa,
    selectedColaborador,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    selectedDepartamento,
    selectedActivo,
    selectedEstadoFactura,
    selectedEstadoPago,
    selectedGastos,
    notasConGastos,
    entregado
  ]);


    function autorizar(id) {
    const URL_AUTORIZADO = `${URL_SURTIDOS}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              entregado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Entregado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }

  function saveFotoEvidencia() {
    Swal.fire({
      title: `Por favor espere...`,
      html: "data uploading",
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    // Si hay impuestos sube la evidencia 2
    if (impuestosMail == 16) {
      const formData2 = new FormData();
      formData2.append("file", fileFotoEvidencia2);
      formData2.append("nombre", `${idEvidencia}`);

      axios
        .post(URL_UPMEDIA, formData2, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(() => {
          setFotoEvidencia2("Si");
          axios
            .patch(
              `${URL_SURTIDOS}/${idEvidencia}`,
              {
                fotoEvidencia: "Si",
                mail: "Si",
                noFactura,
                noGuia
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Enviado con exito!",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }

    const formData = new FormData();
    formData.append("file", fileFotoEvidencia);
    formData.append("nombre", `${idEvidencia}`);

    axios
      .post(URL_UPMEDIA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        setFotoEvidencia("Si");
        axios
          .patch(
            `${URL_SURTIDOS}/${idEvidencia}`,
            {
              fotoEvidencia: "Si",
              mail: "Si",
              noGuia,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            Swal.fire({
              position: "center",
              icon: "success",
              title: `Se guardaron los datos`,
              showConfirmButton: false,
              timer: 1000,
            });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });

    // if (enviarMail == "No") {
    axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOCMail}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allArticulosSurtido = response.data;
        // Totales actuales del servidor (ver PDFOC): los del estado se cargaron
        // al abrir la ventana del correo y pueden ser de antes de una edición
        let subTotalPDF = Number(subTotalMail) || 0;
        let ivaPDF = Number(ivaMail) || 0;
        let totalPDF = Number(total_generalMail) || 0;
        try {
          const t = await totalesNotaActuales(idPDFOCMail);
          subTotalPDF = t.subTotal;
          ivaPDF = t.iva;
          totalPDF = t.total_general;
        } catch (e) {
          console.log("[totales nota correo]", e);
        }
        let arrayTabla = [];

        if (allArticulosSurtido.length > 10) {
          arrayTabla = allArticulosSurtido.map((a) => {
            return {
              id: a.inventarios[0]._id,
              codigo: a.articulos[0].codigo,
              articulos: a.articulos[0].nombre + " " + a.articulos[0].lineas[0].name + " " + a.articulos[0].familias[0].name,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: precioDeLinea(a),
              descuento: descuentoDeLinea(a),
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              fotoArticulo: a.articulos[0].foto,
              foto: process.env.PUBLIC_URL + "sinImagen.png",
            };
          }).filter(function (el) {
            return el != null;
          });
        } else {
          arrayTabla = allArticulosSurtido.map((a) => {
            let foto = a.articulos[0].foto === "No"
              ? process.env.PUBLIC_URL + "sinImagen.png"
              : a.articulos[0].urlFoto;
        
            return {
              id: a.inventarios[0]._id,
              codigo: a.articulos[0].codigo,
              articulos: a.articulos[0].nombre + " " + a.articulos[0].lineas[0].name + " " + a.articulos[0].familias[0].name,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: precioDeLinea(a),
              descuento: descuentoDeLinea(a),
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              fotoArticulo: a.articulos[0].foto,
              foto: foto,
            };
          }).filter(function (el) {
            return el != null;
          });
        }

        let dataFinal = Object.values(arrayTabla);
        revisaCuadreNota(dataFinal, subTotalPDF, numeroMail);

        let agrupado = dataFinal.reduce(function (groups, item) {
          // Mismo artículo a distinto precio/descuento = renglones distintos
          const val = claveRenglon(item);
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
            cajas: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].cajas += item.cajas;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          groups[val].descuento = item.descuento || 0;
          groups[val].codigo = item.codigo;
          groups[val].foto = item.foto;
          groups[val].fotoArticulo = item.fotoArticulo;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);
        let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);

        let TC = agrupadoValues.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let totalParcial = 0;

        const hayDescuentos = agrupadoValues.some((a) => parseFloat(a.descuento || 0) > 0);

        const data = agrupadoValues.map((a) => {
          const descPct = parseFloat(a.descuento || 0);
          totalParcial = a.cantidad * a.precio * (1 - descPct / 100);
          const cols = [
            a.foto,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.codigo,
            a.articulos,
            new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.cajas),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.precio),
          ];
          if (hayDescuentos) {
            cols.push(descPct > 0 ? `${descPct.toFixed(2)}%` : "-");
          }
          cols.push(
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalParcial)
          );
          return cols;
        });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });

        const columnStyles = hayDescuentos
          ? [
              { fontSize: .000001, textColor: [255, 255, 255], cellWidth: 20, },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"], halign: "right" },
              { fontSize: 9, textColor: ["#000000"], halign: "center" },
              { fontSize: 9, textColor: ["#000000"], halign: "right" },
            ]
          : [
              { fontSize: .000001, textColor: [255, 255, 255], cellWidth: 20, },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"] },
              { fontSize: 9, textColor: ["#000000"], halign: "right" },
              { fontSize: 9, textColor: ["#000000"], halign: "right" },
            ];

        const doc = new jsPDF({ compressPdf: true });
        var img = new Image();
        var img2 = new Image();
        const backgroundColor = ["#d1d2d4"];
        const backgroundColorBoxLightGray = ["#e6e7e9"];
        const backgroundColorBoxBlack = ["#231f20"];
        const backgroundColorBoxPurple = ["#B02307"];
        const margins = { left: 5, right: 5 };

        img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img, "png", 15, 5, 33, 20);

        // img.src = process.env.PUBLIC_URL + "marcas.png";
        // doc.addImage(img, "png", 9, 28, 192, 10);
        // doc.setFontSize(10);

        doc.setFillColor(...backgroundColor);
        doc.rect(5, 40, 200, 6, "F");
        doc.setTextColor("#000000");
        doc.text(`Tel: 55 1234 5678`, 8, 44);

        doc.setTextColor("#000000");
        doc.text(`Cliente: ${codigoClientesMail} - ${clientesMail}`, 8, 52);
        doc.text(`Remisión: ${numeroMail}`, 80, 52);
        doc.text(`Cotización: ${pedidosMail}`, 155, 52);

        doc.setTextColor("#B02307");
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(`macuro.mx`, 175, 44);
        doc.setTextColor("#000000");

        doc.setFontSize(14);
        doc.setFillColor(...backgroundColorBoxBlack);
        doc.rect(100, 4, 105, 22, "F");
        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(74, 4, 25, 22, "F");
        doc.setTextColor("#ffffff");
        doc.text(`NOTA DE SALIDA`, 125, 12);
        doc.setFont("helvetica", "normal");
        doc.text(`SALIDA BODEGA`, 125, 17);
        doc.text(`México, D. F. a ${fechaMail}`, 125, 22);

        doc.autoTable({
          head: [
            hayDescuentos
              ? ["", "CANTIDAD", "MODELO", "DESCRIPCION", "BULTO#", "PRECIO UNITARIO", "DESC %", "IMPORTE"]
              : ["", "CANTIDAD", "MODELO", "DESCRIPCION", "BULTO#", "PRECIO UNITARIO", "IMPORTE"],
          ],
          body: dataPDFLimpia,
          bodyStyles:{
            rowHeight : 22,
            valign: "middle"
          },
          styles: {
            fontSize: 10,
            overflow: "linebreak",
            columnWidth: "wrap",
            // font: 'arial',
            overflowColumns: "linebreak",
          },
          headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0,
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          columnStyles: columnStyles,
          theme: "grid",
          margin: { left: 5, right: 5 },
          startY: 55,
          showFoot: "lastPage",


        didDrawCell: function(data) {
          if (data.column.index === 0 && data.cell.section === 'body') {
             var td = data.cell.raw;
             var img = td
            //  var dim = data.cell.height - data.cell.padding('vertical');
             var textPos = data.cell;
             doc.addImage(img, textPos.x,  textPos.y, 20, 20);
          }
        },

        });


        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(5, doc.autoTable.previous.finalY + 1, 36, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFontSize(8);
        doc.text(`TOTAL DE ARTICULOS`, 7, doc.autoTable.previous.finalY + 5);
        doc.setTextColor("#000000");
        doc.text(
          `________________________________________________________________________________________________________________________________`,
          5,
          doc.autoTable.previous.finalY + 22
        );

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setFont("helvetica", "normal");
        doc.rect(40, doc.autoTable.previous.finalY + 1, 40, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US").format(TM) + " Piezas",
          42,
          doc.autoTable.previous.finalY + 5
        );

        doc.setFontSize(7.5);
        doc.text(
          `1. Esta es una venta en firme y no se acepta ningún tipo de descuento o devolución sin consentimiento previo.`,
          5,
          doc.autoTable.previous.finalY + 11
        );
        doc.text(
          `2. La mercancía viaja por cuenta y riesgo del cliente, no somos responsables por faltante.`,
          5,
          doc.autoTable.previous.finalY + 14
        );
        doc.text(
          `3. El pago de la mercancía debe realizarse en tiempo y forma pactados a la cuenta proporcionada por nosotros.`,
          5,
          doc.autoTable.previous.finalY + 17
        );

        var observaciones = `Observaciones: ${observacionesMail}`;
        var lines = doc.splitTextToSize(observaciones, 129);
        doc.text(5, doc.autoTable.previous.finalY + 26, lines);

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 1, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`SUBTOTAL $`, 153, doc.autoTable.previous.finalY + 5);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 1, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(subTotalPDF.toFixed(2)),
          183,
          doc.autoTable.previous.finalY + 5
        );

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 8, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`IMPUESTO $`, 154, doc.autoTable.previous.finalY + 12);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 8, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US").format(ivaPDF),
          183,
          doc.autoTable.previous.finalY + 12
        );

        doc.setFillColor(...backgroundColorBoxPurple);
        doc.rect(144, doc.autoTable.previous.finalY + 15, 37, 6, "F");
        doc.setTextColor("#ffffff");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(8);
        doc.text(`TOTAL $`, 159, doc.autoTable.previous.finalY + 19);

        doc.setFillColor(...backgroundColorBoxLightGray);
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "normal");
        doc.rect(181, doc.autoTable.previous.finalY + 15, 24, 6, "F");
        doc.text(
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalPDF.toFixed(2)),
          183,
          doc.autoTable.previous.finalY + 19
        );

        var lines = doc.splitTextToSize(`Observaciones: ${observaciones}`, 40);
        doc.text(145, doc.autoTable.previous.finalY + 26, lines);

        doc.setFont("helvetica", "bold");
        doc.text(
          `Nombre Completo:__________________________________________________________________________  Firma:______________________________`,
          5,
          doc.autoTable.previous.finalY + 50
        );

        doc.setFont("helvetica", "normal");
        doc.setFontSize(6);
        doc.text(
          `ESTE DOCUMENTO NO REPRESENTA UN COMPROBANTE FISCAL`,
          67,
          doc.autoTable.previous.finalY + 60
        );

        // Agrega Evidencia 1
        doc.addPage();
        var img2 = new Image();
        img2.src = URL.createObjectURL(fileFotoEvidencia);

        doc.addImage(img2, "png", 10, 10, 190, 270);

        // Agrega Evidencia 2
        if (impuestosMail == 16) {
          doc.addPage();
          var img3 = new Image();
          img3.src = URL.createObjectURL(fileFotoEvidencia2);

          doc.addImage(img3, "png", 10, 10, 190, 270);
        }

        var att = doc.output("arraybuffer");
        var base64File = encode(att);

        // Envia el Mail
        axios.post(
          URL_SEND_MAIL_ATT,
          {
            subject: `Nota-${numeroMail}.pdf`,
            email: process.env.REACT_APP_MAIL_ADMIN,
            fileName: `Nota-${numeroMail}.pdf`,
            att: base64File,
            text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
                         <th><img width="${
                           process.env.REACT_APP_TAMANO_LOGO_MAIL
                         }" align="center" src="${
              process.env.REACT_APP_LINK_SISTEMA
            }logoInstitucion.png" /></th>
                         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${
                           process.env.REACT_APP_NOMBRE_INSTITUCION
                         }</tr>
                         <tbody>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Ciudad de México a ${fechaMail}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Estimado Cliente: ${clientesMail}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Muy buen día, por medio del presente le doy conocimiento que el día ${fechaMail}, hemos embarcado a ustedes mercancía. Le pido tome nota de la siguiente información:</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Empresa de Transporte: ${paqueteriaMail}.</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Numero de guía: ${paqueteriaMail}.</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Numero de bultos: ${TTC.toFixed(
                           2
                         )}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Nota / Factura: ${numeroMail}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Valor de la Venta: $${new Intl.NumberFormat(
                           "en-US",
                           {
                             style: "currency",
                             currency: "USD",
                             maximumFractionDigits: 2,
                           }
                         ).format(total_generalMail)}</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Plazo convenido: ${plazoMail}</tr>
                         <br>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Adjunto Documento de Venta.</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;><br>Quedamos a sus órdenes para cualquier duda o aclaración.</tr>
                         <br>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;"><br>Atentamente ,</tr>
                         <tr style="font-size:14px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
                         </tbody>
                         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${
                           process.env.REACT_APP_TELEFONO_INSTITUCION
                         }</tr>
                         
                         </table>`,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        // .then(() => {

        // let params = new URLSearchParams({
        //   number: telefonoMail,
        //   message:`Hola ${clientesMail}, Aqui te enviamos la nueva nota de venta`,
        //   fileName:`Nota-${numeroMail}.pdf`,
        //   mimetype: "application/pdf",
        // })
        // axios
        // .post(
        //   `${URL_WHATSAPP}SendPDFFront?${params.toString()}`,
        //   att,
        //   {
        //     headers: {
        //       Authorization: `Bearer: ${localStorage.getItem(
        //         "app_token"
        //       )}`,
        //       "Content-Type": "application/octet-stream",
        //     },
        //   }
        // )
        //   .then(() => {
        //     Swal.fire("Good job!", "Enviado con exito", "success");
        //     setTimeout(() => {
        //       window.location.reload();
        //     }, 1000);
        //   })
        //   .catch((error) => {
        //     Swal.fire({
        //       icon: "error",
        //       title: "Oops...",
        //       text: "Something went wrong!",
        //       footer: `${error.response.data}`,
        //     });
        //   });

      })

      // .catch((error) => {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "Something went wrong!",
      //     footer: `${error.response.data}`,
      //   });
      //   console.log(error);
      // });

      // })
      .catch((err) => {
        console.log(err);
      });
    // }
  }

  function jalaFotoEvidencia(id) {
    setPhotoEvidencia("")
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG}/${id}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhotoEvidencia(data.data.resources);
      })
      .catch((err) => console.log(err));
    toggleVerFotoEvidencia();
  }

  async function enviarWhatsapp(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    vendedor,
    telefono
  ) {
    Swal.fire({
      title: "Estas seguro?",
      text: `Se enviara la Nota al telefono ${telefono}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios
          .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allArticulosSurtido = response.data;
            let arrayTabla = allArticulosSurtido
              .map((a) => {
                return {
                  id: a.inventarios[0]._id,
                  articulos:
                    a.articulos[0].nombre +
                    " " +
                    a.articulos[0].lineas[0].name +
                    " " +
                    a.articulos[0].familias[0].name,
                  cantidad: a.cantidad,
                  idArticulo: a.articulos[0]._id,
                  precio: precioDeLinea(a),
                  cajas: a.cantidad / a.articulos[0].piezasPorCaja,
                };
              })
              .filter(function (el) {
                return el != null;
              });

            let dataFinal = Object.values(arrayTabla);

            let agrupado = dataFinal.reduce(function (groups, item) {
              const val = item["idArticulo"];
              groups[val] = groups[val] || {
                idArticulo: item.idArticulo,
                cantidad: 0,
                cajas: 0,
              };
              groups[val].cantidad += item.cantidad;
              groups[val].cajas += item.cajas;
              groups[val].articulos = item.articulos;
              groups[val].precio = item.precio;
              return groups;
            }, []);

            let agrupadoValues = Object.values(agrupado);

            let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
            let TM = totalMts.reduce((t, total, index) => t + total, 0);

            let TC = agrupadoValues.map((c) => parseFloat(c.cajas));
            let TTC = TC.reduce((t, total, index) => t + total, 0);

            let totalParcial = 0;

            const data = agrupadoValues.map((a) => {
              totalParcial = a.cantidad * a.precio;
              return [
                a.articulos,
                new Intl.NumberFormat("en-US", {
                  maximumFractionDigits: 2,
                }).format(a.cajas),
                new Intl.NumberFormat("en-US").format(a.cantidad),
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(a.precio),
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(totalParcial),
              ];
            });

            const dataPDF = Object.values(data);
            const dataPDFLimpia = dataPDF.filter(function (el) {
              return el != null;
            });
            const doc = new jsPDF({ compressPdf: true });
            var img = new Image();
            var img2 = new Image();
            img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            doc.addImage(img2, "png", 10, 21, 30, 25);

            let alto = 5;

            doc.setFontSize(14);
            doc.text(`MACURO S.A. DE C.V.`, 50, alto + 15);
            doc.setFontSize(10);
            doc.text(
              `Callejon Mixcalco 9`,
              50,
              alto + 20
            );
            doc.text(`Lomas de Chapultepec II Seccion, CDMX, 11000`, 50, alto + 25);
            doc.text(
              `Miguel Hidalgo CDMX, Mexico `,
              50,
              alto + 30
            );

            doc.setFontSize(10);
            doc.text(`Fecha:`, 150, alto + 15);
            doc.text(`${fecha}`, 160, alto + 15);
            doc.text(`Nota:`, 150, alto + 20);
            doc.text(`${numero}`, 160, alto + 20);
            doc.text(`Cotizacion:`, 150, alto + 25);
            doc.text(`${pedidos || ""}`, 160, alto + 25);

            doc.setFontSize(10);
            doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, alto + 55);
            doc.text(`RFC: ${RFC}`, 150, alto + 55);
            doc.text(
              `Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int} Telefono: ${telefono}`,
              10,
              alto + 65
            );
            doc.text(
              `Edo: ${estado}, Ciudad: ${ciudad}, Del: ${delegacion}, Col: ${colonia}, CP: ${cp} Paqueteria: ${paqueteria}`,
              10,
              alto + 70
            );

            doc.autoTable({
              head: [["Articulo", "Cajas", "Cantidad", "Precio", "Total"]],
              body: dataPDFLimpia,
              headStyles: {
                fillColor: ["#B02307"],
                lineWidth: 0,
              },
              footStyles: {
                fillColor: ["#B02307"],
              },
              theme: "grid",
              styles: {
                fontSize: 10,
                overflow: "linebreak",
                columnWidth: "wrap",
                // font: 'arial',
                overflowColumns: "linebreak",
              },
              headStyles: {
                fillColor: ["#B02307"],
                lineWidth: 0,
              },
              footStyles: {
                fillColor: ["#B02307"],
              },
              theme: "grid",
              margin: { left: 5, right: 5 },
              startY: 80,
              foot: [
                [
                  "",
                  new Intl.NumberFormat("en-US").format(TTC.toFixed(2)) +
                    " Cajas",
                  new Intl.NumberFormat("en-US").format(TM) + " Piezas",
                  "Sub Total",
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(subTotal.toFixed(2)),
                ],
                [
                  "",
                  "",
                  "",
                  `Comision`,
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(iva.toFixed(2)),
                ],
                [
                  "",
                  "",
                  "",
                  "Comision TDC",
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(comisionTDC.toFixed(2)),
                ],
                [
                  "",
                  "",
                  "",
                  "Comision Flete",
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format((comisionFlete + comisionTDC).toFixed(2)),
                ],
                [
                  "",
                  "",
                  "",
                  "Total",
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(total_general.toFixed(2)),
                ],
              ],
              showFoot: "lastPage",
            });

            var attW = doc.output("arraybuffer");

          let params = new URLSearchParams({
            number: telefono,
            message:`Hola ${clientes}, Aquí te enviamos la nota de venta #${numero}`,
            fileName:`Nota-${numero}.pdf`,
            mimetype: "application/pdf",
          })
          axios
          .post(
            `${URL_WHATSAPP}SendPDFFront?${params.toString()}`,
            attW,
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem(
                  "app_token"
                )}`,
                "Content-Type": "application/octet-stream",
              },
            }
          )
        })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

    function EditNota(id, clientes, numero, factura) {

    setIdEdit(id);
    setClienteEdit(clientes);
    setNumeroEdit(numero);
    setFacturaEdit(factura);
    setLineasNota([]);

    // Cargar surtido (para saber abonado e impuestos) y sus articulosSurtidos
    Promise.all([
      axios.get(`${URL_SURTIDOS}/${id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }),
      axios.get(`${URL_ARTICULOS_SURTIDOS}/surtido/${id}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }),
    ])
      .then(([rSur, rAS]) => {
        const sur = rSur.data;
        const total = Number(sur.total_general || 0);
        const saldo = Number(sur.saldo || 0);
        setTotalOriginalNota(total);
        setAbonadoNota(total - saldo);
        setImpuestosNota(Number(sur.impuestos || 0));
        const areaIdSur = sur.areas?.[0]?._id || sur.areas?.[0] || sur.areas || "";
        const pedidoIdSur = sur.pedidos?._id || sur.pedidos || "";
        const clienteIdSur = sur.clientes?.[0]?._id || sur.clientes?.[0] || sur.clientes || "";
        setSurtidoAreaEdit(String(areaIdSur));
        setSurtidoPedidoEdit(String(pedidoIdSur));
        setSurtidoClienteEdit(String(clienteIdSur));
        setSurtidoFechaEdit(String(sur.fecha || moment().format("YYYY-MM-DD")));

        const lineas = (rAS.data || []).map((a) => {
          const cantidad = Number(a.cantidad || 0);
          // El precio de venta vive en el ArticuloPedido. NO usar
          // `costoUnitario`: ese campo es el COSTO de la línea, no el precio.
          // Leerlo aquí ponía el costo en la columna de precio y recalculaba
          // el total de la nota hacia abajo (la 418 pasaba de $97,421.73 a
          // $77,137.56). El error estuvo tapado mientras costoUnitario venía
          // en 0 y entraba el fallback; al sellar los costos quedó a la vista.
          const precio = Number(precioDeLinea(a) || 0);
          const descuento = Number(a.articulosPedido?.[0]?.descuento || 0);
          return {
            id: a._id,
            idArticuloRef: a.articulos?.[0]?._id || "",
            articulosNombre: a.articulos?.[0]
              ? `${a.articulos[0].codigo || ""} ${a.articulos[0].nombre || ""}`
              : "",
            cantidad,
            cantidadOriginal: cantidad,
            precio,
            precioOriginal: precio,
            descuento,
            total: cantidad * precio * (1 - descuento / 100),
          };
        });
        setLineasNota(lineas);
        // Lista de precios de la nota: la del pedido si la tiene; si no, se
        // infiere comparando el precio de la primera línea con las listas del
        // artículo (mismo criterio que ListadoPedidos).
        const listaPed = Number(sur.pedidos?.listaPrecios || 0);
        setListaPreciosNota(listaPed > 0 ? listaPed : 0);

        // Cargar catálogo de artículos y inventarios para "Agregar artículo"
        axios
          .get(URL_ARTICULOS, {
            headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          })
          .then((r) => setArticulosBD((r.data || []).filter((a) => a.is_active !== "No")))
          .catch(() => setArticulosBD([]));

        axios
          .get(`${URL_INVENTARIOS}DisponibleAlmacen/${sur.areas?.[0]?._id || sur.areas?.[0] || sur.areas || ""}`, {
            headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          })
          .then((r) => setInventariosBD(r.data || []))
          .catch(() => setInventariosBD([]));

        // Cargar surtidos del cliente con saldo > 0 (para transferencia de excedente)
        const cliId = sur.clientes?.[0]?._id || sur.clientes?.[0] || sur.clientes;
        axios
          .get(`${URL_SURTIDOS}Cliente/${cliId}`, {
            headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          })
          .then((r) => {
            const otros = (r.data || []).filter((s) => String(s._id) !== String(id) && Number(s.saldo) > 0);
            setSurtidosClienteEdit(otros);
          })
          .catch(() => setSurtidosClienteEdit([]));
        setDestinoSurtidoId("");
        setTransferencias({});
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cargar la nota",
        });
      });

    toggleEditNota();
  }

  const cambiarCantidadLinea = (id, val) => {
    setLineasNota(
      lineasNota.map((l) =>
        l.id === id
          ? { ...l, cantidad: Number(val) || 0, total: (Number(val) || 0) * l.precio * (1 - Number(l.descuento || 0) / 100) }
          : l
      )
    );
  };

  const cambiarPrecioLinea = (id, val) => {
    setLineasNota(
      lineasNota.map((l) =>
        l.id === id
          ? { ...l, precio: Number(val) || 0, total: l.cantidad * (Number(val) || 0) * (1 - Number(l.descuento || 0) / 100) }
          : l
      )
    );
  };

  const cambiarDescuentoLinea = (id, val) => {
    setLineasNota(
      lineasNota.map((l) => {
        if (l.id !== id) return l;
        const desc = Math.max(0, Math.min(100, Number(val) || 0));
        return { ...l, descuento: desc, total: l.cantidad * l.precio * (1 - desc / 100) };
      })
    );
  };

  const eliminarLineaNota = (id) => {
    setLineasNota(lineasNota.filter((l) => l.id !== id));
  };

  const agregarArticuloNuevo = () => {
    if (!nuevoArtSel) {
      Swal.fire({ icon: "warning", title: "Selecciona un artículo" });
      return;
    }
    const cant = Number(nuevoArtCantidad) || 0;
    const prec = Number(nuevoArtPrecio) || 0;
    if (cant <= 0 || prec <= 0) {
      Swal.fire({ icon: "warning", title: "Cantidad y precio deben ser > 0" });
      return;
    }
    const desc = Math.max(0, Math.min(100, Number(nuevoArtDescuento) || 0));
    const inv = inventariosBD.find(
      (i) => String(i.articulos?.[0]?._id || i.articulos?.[0]) === String(nuevoArtSel._id)
    );
    setLineasNota([
      ...lineasNota,
      {
        id: "new_" + uuidv4(),
        esNueva: true,
        idArticulo: nuevoArtSel._id,
        articulosNombre: `${nuevoArtSel.codigo || ""} ${nuevoArtSel.nombre || ""}`,
        idInv: inv?._id || null,
        cantidad: cant,
        cantidadOriginal: 0,
        precio: prec,
        precioOriginal: prec,
        descuento: desc,
        total: cant * prec * (1 - desc / 100),
      },
    ]);
    setNuevoArtSel(null);
    setNuevoArtCantidad(1);
    setNuevoArtPrecio(0);
    setNuevoArtDescuento(0);
  };

    function saveEditarNota(){
    const subTotalCalculado = lineasNota.reduce((acc, l) => acc + (Number(l.cantidad) * Number(l.precio) * (1 - Number(l.descuento || 0) / 100)), 0);
    const ivaCalculado = Number(impuestosNota) > 0 ? subTotalCalculado * (Number(impuestosNota) / 100) : 0;
    const totalCalculado = subTotalCalculado + ivaCalculado;

    let transferenciasArr = [];
    if (totalCalculado + 0.005 < abonadoNota) {
      const excedente = Number((abonadoNota - totalCalculado).toFixed(2));
      transferenciasArr = Object.entries(transferencias)
        .map(([surtidoId, importe]) => ({ surtidoId, importe: Number(importe || 0) }))
        .filter((t) => t.importe > 0);
      const suma = transferenciasArr.reduce((s, t) => s + t.importe, 0);
      if (Math.abs(suma - excedente) > 0.01) {
        Swal.fire({
          icon: "error",
          title: "Excedente sin cuadrar",
          text: `El excedente es $${excedente.toFixed(2)} y la suma asignada a las notas destino es $${suma.toFixed(2)}. Ajusta las cantidades.`,
        });
        return;
      }
      // Validar saldo suficiente por nota
      for (const t of transferenciasArr) {
        const s = surtidosClienteEdit.find((x) => String(x._id) === String(t.surtidoId));
        if (!s || Number(s.saldo || 0) + 0.005 < t.importe) {
          Swal.fire({
            icon: "error",
            title: "Saldo insuficiente",
            text: `La nota #${s?.idSurtido || t.surtidoId} no tiene saldo suficiente para $${t.importe.toFixed(2)}.`,
          });
          return;
        }
      }
    }

    Swal.fire({
      title: "Guardando...",
      text: "Actualizando nota, abonos e inventarios",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    Promise.all([
      // Editar factura (campo simple)
      axios.patch(
        `${URL_SURTIDOS}/${idEdit}`,
        { noFactura: facturaEdit },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      ),
      // Editar lineas, totales, inventario y saldo cliente
      axios.patch(
        `${URL_SURTIDOS}EditarNota/${idEdit}`,
        {
          lineas: lineasNota.map((l) => ({
            id: l.id,
            esNueva: !!l.esNueva,
            idArticulo: l.idArticulo || null,
            cantidad: Number(l.cantidad) || 0,
            precio: Number(l.precio) || 0,
            descuento: Number(l.descuento || 0),
          })),
          transferencias: transferenciasArr,
          impuestos: Number(impuestosNota) || 0,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      ),
    ])
    .then(() => {
      axios.post(
        URL_LOGS,
        {
          tipo: "Editar Nota",
          detalle: `${numeroEdit} ${clienteEdit}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      // axios.patch(
      //   URL_SIGNUP_DON,
      //   {
      //     nombre: nombre,
      //     apellido: apellido,
      //     email: email,
      //   },
      //   {
      //     headers: {
      //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //     },
      //   }
      // );
      toggleEditNota();
      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    })


    .catch((error) => {
      const msg = error?.response?.data?.message || error?.response?.data?.error || error?.message || "Something went wrong!";
      Swal.fire({
        icon: "error",
        title: "No se pudo guardar",
        text: msg,
      });
      console.log("editar nota error:", error?.response?.data || error);
    });



  }



  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {/* <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                {selectedSurtidos.length >= 2 && (
                  <Button
                    size="sm"
                    className="btn"
                    color="warning"
                    onClick={facturarMultiplesSurtidos}
                  >
                    Facturar {selectedSurtidos.length} juntos <i className="fas fa-file-invoice-dollar"></i>
                  </Button>
                )}
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="warning"
                  onClick={() => {
                    setGxFilas([]);
                    setGxResultado(null);
                    setGxArchivo("");
                    setModalGastosExcel(true);
                  }}
                  title="Subir un Excel con costos de envío por número de pedido"
                >
                  Gastos Excel <i className="fas fa-truck"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Notas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ventas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                // bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                // bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            {/* <Col md={2}>
              <Label>Empresas</Label>
              <Input
                // bsSize="sm"
                type="select"
                value={selectedEmpresa}
                onChange={(e) => {
                  setSelectedEmpresa(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {empresas
                  .sort((a, b) =>
                    a.name > b.name ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col> */}
            <Col md={2}>
              <Label>Clientes</Label>
              <Autocomplete
                size="small"
                value={valueClienteFiltro}
                options={clientes.sort((a, b) =>
                  a.nombre_comercial > b.nombre_comercial ? 1 : -1
                )}
                getOptionLabel={(o) => o.nombre_comercial || ""}
                getOptionSelected={(o, v) => o._id === (v && v._id)}
                onChange={(_, v) => {
                  setValueClienteFiltro(v);
                  setSelectedCliente(v ? v._id : "");
                  setCurrentPage(1);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Selecciona" variant="outlined" />
                )}
              />
            </Col>
            <Col md={2}>
              <Label>Estado Factura</Label>
              <Input
                // bsSize="sm"
                type="select"
                value={selectedEstadoFactura}
                onChange={(e) => {
                  setSelectedEstadoFactura(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                <option value="Pendiente">Pendiente</option>
                <option value="Pendiente facturar">Pendiente facturar</option>
                <option value="Facturado">Facturado</option>
                <option value="No requiere">No requiere</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Estado Pago</Label>
              <Input
                // bsSize="sm"
                type="select"
                value={selectedEstadoPago}
                onChange={(e) => {
                  setSelectedEstadoPago(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                <option value="Liquidada">Liquidada</option>
                <option value="Pendiente">Pendiente</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Gastos directos</Label>
              <Input
                type="select"
                value={selectedGastos}
                onChange={(e) => {
                  setSelectedGastos(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                <option value="Con">Con gastos</option>
                <option value="Sin">Sin gastos</option>
                <option value="NoLleva">No llevan gasto</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Vendedores</Label>
              <Input
                // bsSize="sm"
                type="select"
                value={selectedColaborador}
                onChange={(e) => {
                  setSelectedColaborador(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Activa</Label>
              <Input
                // bsSize="sm"
                type="select"
                value={selectedActivo}
                onChange={(e) => {
                  setSelectedActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if (a.is_active == "No") {
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c" }}>
                      <td>{a.numero}</td>
                      <td>{a.pedidos}</td>
                      <td>{fDMA(a.fecha)}</td>
                      {/* <td>{a.empresas}</td> */}
                      <td></td>
                      <td>{a.clientes}</td>
                      <td>{a.razon_social}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      {/* <td>{a.departamentoName}</td> */}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>CANCELADA</td>
                      <td></td>
                    </tr>
                  );
                } else {
                  return (
                    <tr
                      style={
                        a.surtidoDiferente === "Si" && a.pdfDescargado === "No"
                          ? { backgroundColor: "#cfe2ff" }
                          : undefined
                      }
                      title={
                        a.surtidoDiferente === "Si" && a.pdfDescargado === "No"
                          ? "Se surtió de más o de menos de lo que pedía el pedido. Se quita el azul al bajar el PDF de la venta."
                          : undefined
                      }
                    >
                      <td>{a.numero}</td>
                      <td>{a.pedidos}</td>
                      <td>{fDMA(a.fecha)}</td>
                      {/* <td>{a.empresas}</td> */}
                      <td>
                        {a.facturado !== "Si" && a.requiereFactura === "Si" && (
                          <input
                            type="checkbox"
                            checked={selectedSurtidos.includes(a._id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedSurtidos([...selectedSurtidos, a._id]);
                              } else {
                                setSelectedSurtidos(selectedSurtidos.filter((id) => id !== a._id));
                              }
                            }}
                          />
                        )}
                      </td>
                      <td>{a.clientes}</td>
                      <td>{a.razon_social}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      {/* <td>{a.departamentoName}</td> */}
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.subTotal)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total_general)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.saldo || 0)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {}).format(
                          a.total_cantidad
                        )}
                      </td>
                      <td>
                        <span
                          style={{
                            color:
                              a.estadoFactura === "Facturado"
                                ? "#28a745"
                                : a.estadoFactura === "No requiere"
                                  ? "#6c757d"
                                  : "#dc3545",
                            fontWeight: "bold",
                          }}
                        >
                          {a.estadoFactura}
                        </span>
                      </td>
                      <td>{a.factura}</td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {a.comisionTxt ? (
                          <span style={{ color: a.comisionPagadaVenta === "Si" ? "#28a745" : "#b8860b", fontWeight: 600 }}>
                            {a.comisionPagadaVenta === "Si" ? "Pagada " : "Por pagar "}
                            {a.comisionTxt}
                          </span>
                        ) : (
                          <span style={{ color: "#6c757d" }}>Sin pagar</span>
                        )}
                      </td>
                      {/* Facturas / Pagos */}
                      <td>
                        <>
                         {/* U17/U18: botón con 3 opciones de factura */}
                         {a.facturado !== "Si" && (
                           <>
                           <Button
                             size="sm"
                             className="btn"
                             color="warning"
                             id={`reqFact-${a._id}`}
                             onClick={() => preguntarFactura(a)}
                           >
                             <i className="fas fa-file-invoice"></i>
                           </Button>
                           <UncontrolledTooltip placement="top" target={`reqFact-${a._id}`}>
                             Requiere factura
                           </UncontrolledTooltip>
                           </>
                         )}
                         {/* U15: facturar directo */}
                         {a.requiereFactura === "Si" && a.facturado !== "Si" && (
                           <>
                           <Button
                             size="sm"
                             className="btn"
                             color="success"
                             id={`facturar-${a._id}`}
                             onClick={() => previewFacturar(a)}
                           >
                             <i className="fas fa-receipt"></i>
                           </Button>
                           <UncontrolledTooltip placement="top" target={`facturar-${a._id}`}>
                             Facturar
                           </UncontrolledTooltip>
                           </>
                         )}
                         {/* V19: agregar pago directo desde la venta (modal).
                             Si la venta ya está facturada, el botón redirige a
                             /ComplementosPagoCreate para timbrar un CFDI de pago
                             en vez de registrar un abono adicional. */}
                         {/* Descargar CFDI de la factura (PDF o XML) */}
                         {a.facturado === "Si" && a.idFacturama && (
                           <>
                           <Button
                             size="sm"
                             className="btn"
                             color="success"
                             id={`descCFDI-${a._id}`}
                             onClick={() => descargarFacturaCFDI(a)}
                           >
                             <i className="fas fa-file-download"></i>
                           </Button>
                           <UncontrolledTooltip placement="top" target={`descCFDI-${a._id}`}>
                             Descargar factura (PDF / XML)
                           </UncontrolledTooltip>
                           </>
                         )}
                         {a.facturado === "Si" ? (
                           <>
                           <Button
                             size="sm"
                             className="btn"
                             color="primary"
                             id={`compPago-${a._id}`}
                             onClick={() => { window.location.href = "/ComplementosPagoCreate"; }}
                           >
                             <i className="fas fa-file-invoice-dollar"></i>
                           </Button>
                           <UncontrolledTooltip placement="top" target={`compPago-${a._id}`}>
                             Crear Complemento de Pago
                           </UncontrolledTooltip>
                           </>
                         ) : (
                           <>
                           <Button
                             size="sm"
                             className="btn"
                             color="primary"
                             id={`pago-${a._id}`}
                             onClick={() => abrirModalPago({ ...a, esComplemento: false })}
                           >
                             <i className="fas fa-dollar-sign"></i>
                           </Button>
                           <UncontrolledTooltip placement="top" target={`pago-${a._id}`}>
                             Agregar pago
                           </UncontrolledTooltip>
                           </>
                         )}
                        </>
                      </td>
                      {/* Edición / PDF */}
                      <td>
                        <>
                          {/* Notas que no llevan gasto directo: se marcan para
                              que dejen de salir en el filtro "Sin gastos". */}
                          {!notasConGastos.has(String(a._id)) || a.sinGastoDirecto === "Si" ? (
                            <>
                              <Button
                                size="sm"
                                className="btn"
                                color={a.sinGastoDirecto === "Si" ? "dark" : "light"}
                                id={`sinGasto-${a._id}`}
                                onClick={() => cambiaSinGasto(a)}
                              >
                                <i className="fas fa-truck"></i>
                                {a.sinGastoDirecto === "Si" ? <i className="fas fa-times" style={{ marginLeft: 2, fontSize: 10 }}></i> : null}
                              </Button>
                              <UncontrolledTooltip placement="top" target={`sinGasto-${a._id}`}>
                                {a.sinGastoDirecto === "Si"
                                  ? "Marcada: no lleva gasto directo (click para quitar la marca)"
                                  : "Marcar que no lleva gasto directo"}
                              </UncontrolledTooltip>
                            </>
                          ) : null}
                          {/* Modificar una nota queda restringido al mismo
                              permiso que cancelarla: sólo los Admin. El back
                              lo valida también (requierePermiso). */}
                          {user.menu_surtidos ? (
                            <>
                            <Button
                              color="info"
                              id={`editNota-${a._id}`}
                              size="sm"
                              disabled={!user?.cancelarNotas}
                              onClick={(e) =>
                                user?.cancelarNotas &&
                                EditNota(
                                  a._id,
                                  a.clientes,
                                  a.numero,
                                  a.noFactura
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            <UncontrolledTooltip placement="top" target={`editNota-${a._id}`}>
                              {!user?.cancelarNotas
                                ? "Sólo un Admin puede modificar una nota"
                                : "Editar nota (cantidades / precios)"}
                            </UncontrolledTooltip>
                            <Button
                              color="dark"
                              id={`fechaNota-${a._id}`}
                              size="sm"
                              disabled={!user?.cancelarNotas}
                              onClick={() => user?.cancelarNotas && cambiarFechaNota(a)}
                            >
                              <i className="far fa-calendar-alt"></i>
                            </Button>
                            <UncontrolledTooltip placement="top" target={`fechaNota-${a._id}`}>
                              {!user?.cancelarNotas
                                ? "Sólo un Admin puede cambiar la fecha"
                                : "Cambiar la fecha de la nota"}
                            </UncontrolledTooltip>
                            </>
                          ) : null}
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            id={`pdfVenta-${a._id}`}
                            onClick={(e) => {
                              Swal.fire({
                                title: "PDF de la venta",
                                text: "¿Cómo deseas el PDF?",
                                icon: "question",
                                input: "radio",
                                inputOptions: {
                                  con: "Con imágenes",
                                  sin: "Sin imágenes",
                                },
                                inputValue: "con",
                                showCancelButton: true,
                                confirmButtonText: "Generar",
                                cancelButtonText: "Cancelar",
                                confirmButtonColor: "#911c04",
                                inputValidator: (value) => {
                                  if (!value) return "Selecciona una opción";
                                },
                              }).then((result) => {
                                if (!result.value) return;
                                const conImagenes = result.value === "con";
                                const pdf = PDFOC(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.calle,
                                  a.numero_ext,
                                  a.numero_int,
                                  a.pais,
                                  a.estado,
                                  a.ciudad,
                                  a.delegacion,
                                  a.colonia,
                                  a.cp,
                                  a.RFC,
                                  a.paqueteria,
                                  a.area,
                                  a.codigoClientes,
                                  a.vendedor,
                                  a.telefono,
                                  a.descuento,
                                  conImagenes
                                );
                                // Ya se bajó el PDF: se quita el azul
                                if (a.pdfDescargado === "No") {
                                  Promise.resolve(pdf).then(() => marcaNota(a, { pdfDescargado: "Si" }));
                                }
                              });
                            }}
                          >
                            <i class="far fa-file-pdf"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target={`pdfVenta-${a._id}`}>
                            PDF de la venta
                          </UncontrolledTooltip>
                          {/* Ver la nota sin bajarla al disco */}
                          <Button
                            size="sm"
                            className="btn"
                            color="secondary"
                            id={`verVenta-${a._id}`}
                            onClick={() =>
                              PDFOC(
                                a.fecha, a.idClientes, a.clientes, a.observaciones,
                                a.numero, a._id, a.user, a.pedidos, a.comisionTDC,
                                a.comisionFlete, a.impuestos, a.subTotal, a.iva,
                                a.total_general, a.calle, a.numero_ext, a.numero_int,
                                a.pais, a.estado, a.ciudad, a.delegacion, a.colonia,
                                a.cp, a.RFC, a.paqueteria, a.area, a.codigoClientes,
                                a.vendedor, a.telefono, a.descuento,
                                true,  // con imágenes
                                true   // sólo ver
                              )
                            }
                          >
                            <i className="far fa-eye"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target={`verVenta-${a._id}`}>
                            Ver la nota sin descargarla
                          </UncontrolledTooltip>
                          {/* Gastos directos de esta venta */}
                          <Button
                            size="sm"
                            className="btn"
                            color="warning"
                            id={`gastosVenta-${a._id}`}
                            onClick={() => abrirGastos(a)}
                          >
                            <i className="fas fa-hand-holding-usd"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target={`gastosVenta-${a._id}`}>
                            Gastos directos de la venta
                          </UncontrolledTooltip>
                          {/* C9: PDF Peso */}
                          {/* <Button
                            size="sm"
                            className="btn"
                            color="warning"
                            id={`pdfPeso-${a._id}`}
                            onClick={() =>
                              PDFPeso(a._id, a.numero, a.clientes, a.fecha, a.area)
                            }
                          >
                            <i class="fas fa-weight-hanging"></i>
                          </Button>
                          <UncontrolledTooltip placement="top" target={`pdfPeso-${a._id}`}>
                            PDF Peso
                          </UncontrolledTooltip> */}
                          {/* <Button
                            size="sm"
                            className="btn"
                            color="warning"
                            title="PDF con codigos de barras"
                            onClick={(e) =>
                              PDFBarrasSurtido(a._id, a.numero, a.clientes)
                            }
                          >
                            <i class="fas fa-barcode"></i>
                          </Button> */}
                          {/* <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={(e) => excelOC(a._id, a.numero)}
                          >
                            <i class="far fa-file-excel"></i>
                          </Button> */}
                          {/* {user.altaEvidencia ? (
                            <Button
                              size="sm"
                              color="gris"
                              onClick={(e) => {
                                setidEvidencia(a._id);
                                setFotoEvidencia(a.fotoEvidencia);

                                setEnviarMail(a.mail);
                                setFechaMail(a.fecha);
                                setIdClientesMail(a.idClientes);
                                setClientesMail(a.clientes);
                                setObservacionesMail(a.observaciones);
                                setNumeroMail(a.numero);
                                setIdPDFOCMail(a._id);
                                setUserMail(a.user);
                                setPedidosMail(a.pedidos);
                                setComisionTDCMail(a.comisionTDC);
                                setComisionFleteMail(a.comisionFlete);
                                setImpuestosMail(a.impuestos);
                                setSubTotalMail(a.subTotal);
                                setIvaMail(a.iva);
                                setTotal_generalMail(a.total_general);
                                setCalleMail(a.calle);
                                setNumero_extMail(a.numero_ext);
                                setNumero_intMail(a.numero_int);
                                setPaisMail(a.pais);
                                setEstadoMail(a.estado);
                                setCiudadMail(a.ciudad);
                                setDelegacionMail(a.delegacion);
                                setColoniaMail(a.colonia);
                                setCpMail(a.cp);
                                setRFCMail(a.RFC);
                                setPaqueteriaMail(a.paqueteria);
                                setAreaMail(a.area);
                                setCodigoClientesMail(a.codigoClientes);
                                setVendedorMail(a.vendedor);
                                setTelefonoMail(a.telefono);
                                setPlazoMail(a.plazo);
                                setNoFactura(a.noFactura);
                                setNoGuia(a.noGuia);

                                toggleEvidencia();
                              }}
                            >
                              <i class="fas fa-file-alt"></i>
                            </Button>
                          ) : (
                            <Button size="sm" color="gris" disabled>
                              <i class="fas fa-file-alt"></i>
                            </Button>
                          )} */}
                          {/* {a.fotoEvidencia == "Si" ? (
                            <Button
                              color="success"
                              className="btn btn-gris"
                              size="sm"
                              onClick={(e) => {
                                jalaFotoEvidencia(a._id);
                              }}
                            >
                              <i class="fas fa-camera"></i>
                            </Button>
                          ) : undefined} */}

                          {/* <Button
                              size="sm"
                              className="btn"
                              color="success"
                              onClick={(e) =>
                                enviarWhatsapp(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.calle,
                                  a.numero_ext,
                                  a.numero_int,
                                  a.pais,
                                  a.estado,
                                  a.ciudad,
                                  a.delegacion,
                                  a.colonia,
                                  a.cp,
                                  a.RFC,
                                  a.paqueteria,
                                  a.area,
                                  a.codigoClientes,
                                  a.vendedor,
                                  a.telefono
                                )
                              }
                            >
                              <i class="fab fa-whatsapp"></i>
                            </Button> */}
                            {/* {a.entregado == "No" ? (
 <Button
                                        color="primary"
                                        // id="Baja"
                                        onClick={(e) =>
                                          autorizar(a._id)
                                        }
                                        size="sm"
                                      >
                                        <i class="fas fa-thumbs-up"></i>
                                      </Button>
                            ):undefined} */}

                         <span id={`cancelarWrap-${a._id}`}>
                           <Button
                             size="sm"
                             className="btn"
                             color="danger"
                             disabled={!user?.cancelarNotas}
                             onClick={() =>
                               user?.cancelarNotas &&
                               cancelarNota(a._id, a.numero)
                             }
                           >
                             <i className="fas fa-ban"></i>
                           </Button>
                         </span>
                         <UncontrolledTooltip placement="top" target={`cancelarWrap-${a._id}`}>
                           {!user?.cancelarNotas
                             ? "No tienes permisos para cancelar notas"
                             : "Cancelar nota"}
                         </UncontrolledTooltip>
                        </>
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                {/* Numero */}<td></td>
                {/* Cotizacion */}<td></td>
                {/* Fecha */}<td></td>
                {/* Sel */}<td></td>
                {/* Cliente */}<td></td>
                {/* Razon Social */}<td></td>
                {/* Almacen */}<td></td>
                {/* Vendedor */}<td className="negrita" align="right">TOTAL</td>
                {/* SubTotal */}
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(subTotalImporteTabla)}
                </td>
                {/* Total */}
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalImporteTabla)}
                </td>
                {/* Saldo */}
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(saldoImporteTabla)}
                </td>
                {/* Piezas */}
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalPiezasTabla)}
                </td>
                {/* Estado Factura */}<td></td>
                {/* Factura */}<td></td>
                {/* Comisión */}<td></td>
                {/* Facturas / Pagos */}<td></td>
                {/* Edición / PDF */}<td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <Modal size="lg" isOpen={modalEvidencia} toggle={toggleEvidencia}>
            <ModalHeader toggle={toggleEvidencia}>
              <h4>Evidencias</h4>
            </ModalHeader>
            <ModalBody>
              {impuestosMail > 0.1 ? (
                <>
                  <Row>
                    <Col md={3}>
                      <Label for="exampleEmail" className="mr-sm-2">
                        # Factura
                      </Label>
                      <Input
                        type="text"
                        placeholder="NoFactura"
                        value={noFactura}
                        required
                        onChange={(e) => {
                          setNoFactura(e.target.value);
                        }}
                      />
                    </Col>
                    <Col md={3}>
                      <Label for="exampleEmail" className="mr-sm-2">
                        # Guia
                      </Label>
                      <Input
                        type="text"
                        placeholder="NoGuia"
                        value={noGuia}
                        required
                        onChange={(e) => {
                          setNoGuia(e.target.value);
                        }}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                <Row>
                <Col md={3}>
                      <Label for="exampleEmail" className="mr-sm-2">
                        # Guia
                      </Label>
                      <Input
                        type="text"
                        placeholder="NoGuia"
                        value={noGuia}
                        required
                        onChange={(e) => {
                          setNoGuia(e.target.value);
                        }}
                      />
                    </Col>
                </Row>
                </>
              )}
              <br />
              <Row>
                <Col md={6}>
                  <Label>Evidencia 1</Label>
                  <Input
                    type="file"
                    onChange={(e) => {
                      setFileFotoEvidencia(e.target.files[0]);
                      setFotoEvidencia("No");
                    }}
                  />
                </Col>
              </Row>
              {impuestosMail > 0.1 ? (
                <>
                  <br />
                  <Row>
                    <Col md={6}>
                      <Label>Evidencia 2</Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          setFileFotoEvidencia2(e.target.files[0]);
                          setFotoEvidencia2("No");
                        }}
                      />
                    </Col>
                  </Row>
                </>
              ) : undefined}

               

              <br />
              <Button
                color="success"
                className="btn"
                onClick={(e) => {
                  saveFotoEvidencia();
                }}
                disabled={
                  !(
                    (impuestosMail > 0.1 &&
                      fileFotoEvidencia &&
                      fotoEvidencia === "No" &&
                      fileFotoEvidencia2 &&
                      fotoEvidencia2 === "No") ||
                    (impuestosMail === 0 &&
                      fileFotoEvidencia &&
                      fotoEvidencia === "No")
                  )
                }
              >
                Subir
              </Button>
            </ModalBody>
            <ModalFooter></ModalFooter>
          </Modal>

          <Modal
            size="xxl"
            isOpen={modalVerFotoEvidencia}
            toggle={toggleVerFotoEvidencia}
          >
            <ModalHeader toggle={toggleVerFotoEvidencia}>
              <h4>Evidencias</h4>
            </ModalHeader>
            <ModalBody>
              <Row>
                {photoEvidencia.length > 0 ? (
                  photoEvidencia.map((a) => {
                    return (
                      <h6 style={{ textAlign: "center" }}>
                        <img src={a.secure_url} width="500" height="auto" />
                      </h6>
                    );
                  })
                ) : (
                  <h4>Espera a que se carguen las fotos</h4>
                )}
              </Row>
            </ModalBody>
          </Modal>

                <Modal size="xl" isOpen={modalEditNota} toggle={toggleEditNota}>
        <ModalHeader toggle={toggleEditNota}>
          <h4>Editar Nota {numeroEdit} — Cliente {clienteEdit}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Factura</Label>
              <Input
                bsSize="sm"
                type="text"
                value={facturaEdit}
                onChange={(e) => setFacturaEdit(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label>Total Original</Label>
              <Input bsSize="sm" type="text" disabled value={`$${Number(totalOriginalNota).toFixed(2)}`} />
            </Col>
            <Col md={2}>
              <Label>Abonado</Label>
              <Input bsSize="sm" type="text" disabled value={`$${Number(abonadoNota).toFixed(2)}`} />
            </Col>
            <Col md={2}>
              <Label>IVA %</Label>
              <Input
                bsSize="sm"
                type="select"
                value={impuestosNota}
                onChange={(e) => setImpuestosNota(Number(e.target.value) || 0)}
              >
                <option value="0">0 (Sin IVA)</option>
                <option value="16">16 (Con IVA)</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Lista de Precios</Label>
              <Input
                bsSize="sm"
                type="select"
                value={listaPreciosNota || 1}
                onChange={(e) => cambiarListaPreciosNota(e.target.value)}
                title="Cambia el precio de todas las líneas a la lista elegida"
              >
                <option value="1">Lista 1 (base)</option>
                <option value="2">Lista 2 (-30%)</option>
                <option value="3">Lista 3 (-25%)</option>
                <option value="4">Lista 4 (-20%)</option>
                <option value="5">Lista 5 (-15%)</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Nuevo Total</Label>
              <Input
                bsSize="sm"
                type="text"
                disabled
                value={(() => {
                  const st = lineasNota.reduce(
                    (acc, l) => acc + Number(l.cantidad) * Number(l.precio) * (1 - Number(l.descuento || 0) / 100),
                    0
                  );
                  const t = Number(impuestosNota) > 0 ? st * (1 + Number(impuestosNota) / 100) : st;
                  return `$${t.toFixed(2)}`;
                })()}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={5}>
              <Label>Articulo</Label>
              <Autocomplete
                size="small"
                value={nuevoArtSel}
                options={articulosBD}
                getOptionLabel={(o) => `${o.codigo || ""} ${o.nombre || ""}`}
                getOptionSelected={(o, v) => o._id === (v && v._id)}
                onChange={(_, v) => {
                  setNuevoArtSel(v);
                  if (v) setNuevoArtPrecio(Number(v.venta || v.precioTienda || 0));
                }}
                renderInput={(params) => <TextField {...params} label="Agregar artículo" variant="outlined" />}
              />
            </Col>
            <Col md={2}>
              <Label>Cantidad</Label>
              <Input bsSize="sm" type="number" min="1" step="1" value={nuevoArtCantidad} onChange={(e) => setNuevoArtCantidad(e.target.value)} />
            </Col>
            <Col md={2}>
              <Label>Precio</Label>
              <Input bsSize="sm" type="number" min="0" step="any" value={nuevoArtPrecio} onChange={(e) => setNuevoArtPrecio(e.target.value)} />
            </Col>
            <Col md={1}>
              <Label>Desc %</Label>
              <Input bsSize="sm" type="number" min="0" max="100" step="any" value={nuevoArtDescuento} onChange={(e) => setNuevoArtDescuento(e.target.value)} />
            </Col>
            <Col md={2} style={{ display: "flex", alignItems: "flex-end" }}>
              <Button size="sm" color="success" onClick={agregarArticuloNuevo}>
                <i className="fas fa-plus"></i> Agregar
              </Button>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless>
            <thead>
              <tr>
                <th>Articulo</th>
                <th>Cantidad</th>
                <th>Precio</th>
                <th>Desc %</th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {lineasNota.map((l) => (
                <tr key={l.id}>
                  <td>{l.articulosNombre}</td>
                  <td>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      step="1"
                      value={l.cantidad}
                      onChange={(e) => cambiarCantidadLinea(l.id, e.target.value)}
                      style={{ maxWidth: 120 }}
                    />
                  </td>
                  <td>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      step="any"
                      value={l.precio}
                      onChange={(e) => cambiarPrecioLinea(l.id, e.target.value)}
                      style={{ maxWidth: 140 }}
                    />
                  </td>
                  <td>
                    <Input
                      bsSize="sm"
                      type="number"
                      min="0"
                      max="100"
                      step="any"
                      value={l.descuento || 0}
                      onChange={(e) => cambiarDescuentoLinea(l.id, e.target.value)}
                      style={{ maxWidth: 90 }}
                    />
                  </td>
                  <td>
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(Number(l.cantidad) * Number(l.precio) * (1 - Number(l.descuento || 0) / 100))}
                  </td>
                  <td>
                    <Button size="sm" color="danger" onClick={() => eliminarLineaNota(l.id)}>
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
              {lineasNota.length === 0 && (
                <tr>
                  <td colSpan="6" align="center">
                    Cargando líneas...
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {(() => {
            const stCalc = lineasNota.reduce(
              (acc, l) => acc + Number(l.cantidad) * Number(l.precio) * (1 - Number(l.descuento || 0) / 100),
              0
            );
            const tCalc = Number(impuestosNota) > 0 ? stCalc * (1 + Number(impuestosNota) / 100) : stCalc;
            const excedente = Number((abonadoNota - tCalc).toFixed(2));
            if (excedente <= 0.005) return null;
            const sumaAsignada = Object.values(transferencias).reduce((a, b) => a + Number(b || 0), 0);
            const restante = Number((excedente - sumaAsignada).toFixed(2));
            return (
              <div style={{ background: "#fff3cd", padding: 12, borderRadius: 6, marginTop: 10 }}>
                <Label style={{ color: "#856404", fontWeight: "bold" }}>
                  <i className="fas fa-exclamation-triangle"></i>{" "}
                  Excedente ${excedente.toFixed(2)} — Distribuir entre notas pendientes del cliente
                </Label>
                <div style={{ color: restante === 0 ? "#155724" : "#721c24", fontWeight: "bold", marginBottom: 8 }}>
                  Asignado: ${sumaAsignada.toFixed(2)} · Restante: ${restante.toFixed(2)}
                </div>
                {surtidosClienteEdit.length === 0 ? (
                  <div style={{ color: "#721c24" }}>No hay otras notas con saldo pendiente en este cliente.</div>
                ) : (
                  <Table size="sm" borderless>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Nota</th>
                        <th>Fecha</th>
                        <th>Saldo</th>
                        <th>Importe a transferir</th>
                      </tr>
                    </thead>
                    <tbody>
                      {surtidosClienteEdit
                        .sort((a, b) => (a.idSurtido || 0) - (b.idSurtido || 0))
                        .map((s) => {
                          const asignado = Number(transferencias[s._id] || 0);
                          const chk = asignado > 0;
                          const maxLinea = Math.min(Number(s.saldo || 0), asignado + restante);
                          return (
                            <tr key={s._id}>
                              <td>
                                <Input
                                  type="checkbox"
                                  checked={chk}
                                  onChange={(e) => {
                                    const val = e.target.checked ? Math.min(Number(s.saldo || 0), restante + asignado) : 0;
                                    setTransferencias({ ...transferencias, [s._id]: val });
                                  }}
                                />
                              </td>
                              <td>#{s.idSurtido}</td>
                              <td>{s.fecha}</td>
                              <td>${Number(s.saldo).toFixed(2)}</td>
                              <td>
                                <Input
                                  bsSize="sm"
                                  type="number"
                                  min="0"
                                  step="any"
                                  value={asignado}
                                  onChange={(e) => {
                                    const raw = Number(e.target.value) || 0;
                                    const val = Math.max(0, Math.min(maxLinea, raw));
                                    setTransferencias({ ...transferencias, [s._id]: val });
                                  }}
                                  style={{ maxWidth: 160 }}
                                  disabled={!chk}
                                />
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                )}
              </div>
            );
          })()}
          <br />
          <Button size="sm" color="success" onClick={(e) => saveEditarNota()} tabindex="-1">
            Guardar
          </Button>{" "}
          <Button size="sm" color="secondary" onClick={toggleEditNota}>
            Cancelar
          </Button>
        </ModalBody>
      </Modal>

      {/* V19 detalle: Modal Agregar Pago a una nota */}
      <Modal size="lg" isOpen={modalPago} toggle={() => setModalPago(!modalPago)}>
        <ModalHeader toggle={() => setModalPago(!modalPago)}>
          Pago Nota {pagoSurtido?.numero}
        </ModalHeader>
        <ModalBody>
          {pagoSurtido && (
            <>
              <Row style={{ marginBottom: 14 }}>
                <Col md={6}>
                  <div style={{ fontSize: 12, color: "#666" }}>Cliente</div>
                  <div style={{ fontWeight: "bold" }}>{pagoSurtido.clientes}</div>
                </Col>
                <Col md={3}>
                  <div style={{ fontSize: 12, color: "#666" }}>Total</div>
                  <div style={{ fontWeight: "bold" }}>
                    ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(pagoSurtido.total_general || 0)}
                  </div>
                </Col>
                <Col md={3}>
                  <div style={{ fontSize: 12, color: "#666" }}>Saldo actual</div>
                  <div style={{ fontWeight: "bold", color: "#dc3545" }}>
                    ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(parseFloat(pagoSurtido.saldo) || parseFloat(pagoSurtido.total_general) || 0)}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label>Fecha</Label>
                  <Input
                    type="date"
                    bsSize="sm"
                    value={pagoFecha}
                    onChange={(e) => setPagoFecha(e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Importe</Label>
                  <Input
                    type="number"
                    bsSize="sm"
                    step="any"
                    min="0"
                    value={pagoImporte}
                    onChange={(e) => setPagoImporte(e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Label>Forma de Pago</Label>
                  <Input
                    type="select"
                    bsSize="sm"
                    value={pagoFormaPago}
                    onChange={(e) => setPagoFormaPago(e.target.value)}
                  >
                    <option value="Efectivo">Efectivo</option>
                    <option value="Transfer">Transferencia</option>
                    <option value="TDC">TDC</option>
                    <option value="Cheque">Cheque</option>
                  </Input>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col md={6}>
                  <Label>Banco</Label>
                  <Input
                    type="select"
                    bsSize="sm"
                    value={pagoBanco}
                    onChange={(e) => setPagoBanco(e.target.value)}
                  >
                    <option value="">Selecciona banco</option>
                    {pagoBancos
                      .filter((b) => (b.tipo || "Taref") === "Taref")
                      .filter((b) => b._id !== BANCO_DEVOLUCION && b._id !== BANCO_BONIFICACION)
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((b) => (
                        <option key={b._id} value={b._id}>
                          {b.banco} {b.cuenta}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={6}>
                  <Label>Concepto</Label>
                  <Input
                    type="select"
                    bsSize="sm"
                    value={pagoConcepto}
                    onChange={(e) => setPagoConcepto(e.target.value)}
                  >
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificación</option>
                    <option value="Devolucion">Devolución</option>
                  </Input>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col md={12}>
                  <Label>Observaciones</Label>
                  <Input
                    type="text"
                    bsSize="sm"
                    value={pagoObservaciones}
                    onChange={(e) => setPagoObservaciones(e.target.value)}
                  />
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalPago(false)} disabled={pagoGuardando}>
            Cancelar
          </Button>
          <Button color="success" onClick={guardarPagoNota} disabled={pagoGuardando}>
            {pagoGuardando ? "Guardando..." : "Aplicar Pago"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* U15: Modal Vista Previa Factura (estilo Decomax) */}
      <Modal size="xl" isOpen={modalFacturarPreview} toggle={toggleFacturarPreview} style={{ maxWidth: "90%", margin: "0 auto" }}>
        <ModalHeader toggle={toggleFacturarPreview}>
          Vista previa Factura — Nota {facturarSurtido?.numero}
        </ModalHeader>
        <ModalBody>
          {facturarSurtido && (
            <>
              <Row>
                <Col md={6}>
                  <h5>Cliente</h5>
                  {/* Facturar a público en general sin capturar datos fiscales */}
                  <div
                    className="mb-2"
                    style={{
                      padding: 8,
                      borderRadius: 4,
                      backgroundColor: facturarMostrador ? "#fff3cd" : "transparent",
                      border: facturarMostrador ? "1px solid #ffe08a" : "1px solid #eee",
                    }}
                  >
                    <Label check className="mb-0" style={{ fontWeight: 600 }}>
                      <Input
                        type="checkbox"
                        checked={facturarMostrador}
                        onChange={(e) => setFacturarMostrador(e.target.checked)}
                        style={{ marginRight: 8, position: "static" }}
                      />
                      Ventas Mostrador (Público en General)
                    </Label>
                    {facturarMostrador && (
                      <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                        Se timbra al RFC genérico <b>XAXX010101000</b>, régimen 616, uso S01,
                        con la razón social del cliente. <b>No sale como factura global</b>, así
                        que la venta no se adjudica al mes de la fecha de la factura.
                      </div>
                    )}
                  </div>
                  <div className="mb-2">
                    <Label className="mb-1">Datos de Facturación</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={facturarDatosSel}
                      disabled={facturarMostrador}
                      onChange={(e) => setFacturarDatosSel(e.target.value)}
                    >
                      <option value="">Selecciona</option>
                      {facturarDatosOpciones.map((d) => (
                        <option key={d._id} value={d._id}>
                          {(d.alias ? d.alias + " — " : "") + d.razon_social + " (" + d.RFC + ")"}
                        </option>
                      ))}
                    </Input>
                    {facturarDatosOpciones.length === 0 && (
                      <small className="text-danger">
                        El cliente no tiene datos de facturación capturados.
                      </small>
                    )}
                  </div>
                  {(() => {
                    const dSel =
                      facturarDatosOpciones.find((d) => d._id === facturarDatosSel) || null;
                    const src = dSel || facturarCliente || {};
                    return (
                      <>
                        <div><b>Nombre:</b> {src.razon_social || facturarSurtido.clientes}</div>
                        <div><b>RFC:</b> {src.RFC || "—"}</div>
                        <div><b>Uso CFDI:</b> {src.usoCFDI || "—"}</div>
                        <div><b>Forma Pago SAT:</b> {src.formaPagoSAT || "—"}</div>
                        <div><b>Método Pago SAT:</b> {src.metodoPagoSAT || "—"}</div>
                        <div><b>Condiciones Pago:</b> {src.condicionesPagoSAT || "—"}</div>
                        <div><b>Régimen Fiscal:</b> {src.regFiscal || "—"}</div>
                        <div><b>CP:</b> {src.cp || "—"}</div>
                      </>
                    );
                  })()}
                </Col>
                <Col md={6}>
                  <h5>Empresa Emisora</h5>
                  <div className="mb-2">
                    <Label className="mb-1">Empresa</Label>
                    <Input
                      bsSize="sm"
                      type="select"
                      value={facturarEmpresaSel}
                      onChange={(e) => {
                        setFacturarEmpresaSel(e.target.value);
                        setFacturarEmpresa(
                          facturarEmpresasOpciones.find((emp) => emp._id === e.target.value) || null
                        );
                      }}
                    >
                      <option value="">Selecciona</option>
                      {facturarEmpresasOpciones.map((emp) => (
                        <option key={emp._id} value={emp._id}>{emp.name}</option>
                      ))}
                    </Input>
                  </div>
                  {(() => {
                    const eSel =
                      facturarEmpresasOpciones.find((emp) => emp._id === facturarEmpresaSel) ||
                      facturarEmpresa ||
                      {};
                    return (
                      <>
                        <div><b>Nombre:</b> {(eSel.razonSocial && eSel.razonSocial !== "NA") ? eSel.razonSocial : (eSel.name || facturarSurtido.empresas)}</div>
                        <div><b>RFC:</b> {(eSel.rfc && eSel.rfc !== "NA") ? eSel.rfc : "—"}</div>
                        <div><b>Régimen Fiscal:</b> {(eSel.regimenFiscal && eSel.regimenFiscal !== "NA") ? eSel.regimenFiscal : "—"}</div>
                        <div><b>CP:</b> {(eSel.cp && eSel.cp !== "NA") ? eSel.cp : "—"}</div>
                      </>
                    );
                  })()}
                  <br />
                  <Row>
                    <Col md={6}>
                      <Label>Serie</Label>
                      <Input bsSize="sm" type="select" value={facturarSerie} onChange={(e) => setFacturarSerie(e.target.value)}>
                        <option value="">Selecciona</option>
                        {facturarSeries.map((s) => (
                          <option key={s._id || s.serie} value={s.serie}>{s.serie}</option>
                        ))}
                      </Input>
                    </Col>
                    <Col md={6}>
                      <Label>Timbres disponibles</Label>
                      <div><b>{facturarTimbres}</b></div>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col md={6}>
                      <Label>Método de Pago</Label>
                      <Input bsSize="sm" type="select" value={facturarMetodoPago} onChange={(e) => setFacturarMetodoPago(e.target.value)}>
                        <option value="PUE">PUE - Pago en una exhibición</option>
                        <option value="PPD">PPD - Pago en parcialidades o diferido</option>
                      </Input>
                    </Col>
                    {facturarMetodoPago === "PUE" && (
                      <Col md={6}>
                        <Label>Forma de Pago</Label>
                        <Input bsSize="sm" type="select" value={facturarFormaPago} onChange={(e) => setFacturarFormaPago(e.target.value)}>
                          <option value="">Selecciona</option>
                          <option value="01">01 - Efectivo</option>
                          <option value="02">02 - Cheque nominativo</option>
                          <option value="03">03 - Transferencia electrónica</option>
                          <option value="04">04 - Tarjeta de crédito</option>
                          <option value="28">28 - Tarjeta de débito</option>
                          <option value="99">99 - Por definir</option>
                        </Input>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
              <hr />
              <h5>Artículos</h5>
              <Table size="sm" striped>
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Descripción</th>
                    <th align="right">Cantidad</th>
                    <th align="right">Precio</th>
                    <th align="right">Importe</th>
                  </tr>
                </thead>
                <tbody>
                  {facturarArticulos.map((art) => (
                    <tr key={art._id}>
                      <td>{art.articulos?.[0]?.codigo || ""}</td>
                      <td>{art.articulos?.[0]?.nombre || ""}</td>
                      <td align="right">{art.cantidad}</td>
                      <td align="right">
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(precioDeLinea(art) || 0)}
                      </td>
                      <td align="right">
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format((precioDeLinea(art) || 0) * (art.cantidad || 0))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Row className="mt-3">
                <Col md={{ size: 4, offset: 8 }}>
                  <Table size="sm" borderless>
                    <tbody>
                      <tr>
                        <td><b>SubTotal</b></td>
                        <td align="right">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(facturarSurtido.subTotal || 0)}</td>
                      </tr>
                      <tr>
                        <td><b>IVA</b></td>
                        <td align="right">{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(facturarSurtido.iva || 0)}</td>
                      </tr>
                      <tr>
                        <td><b>Total</b></td>
                        <td align="right"><b>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(facturarSurtido.total_general || 0)}</b></td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleFacturarPreview} disabled={facturando}>Cancelar</Button>
          <Button color="success" onClick={confirmarFacturar} disabled={facturando}>
            {facturando ? "Timbrando..." : "Confirmar y Timbrar"}
          </Button>
        </ModalFooter>
      </Modal>
        </div>
      ) : undefined}
      <br />

      {/* Carga de gastos de envío desde Excel */}
      <Modal size="xl" isOpen={modalGastosExcel} toggle={() => !gxTrabajando && setModalGastosExcel(false)}>
        <ModalHeader toggle={() => !gxTrabajando && setModalGastosExcel(false)}>
          <h4>Cargar gastos de envío desde Excel</h4>
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: 13, color: "#555" }}>
            El archivo necesita una columna <b>Pedido</b> (número de pedido) y una <b>Importe</b> (costo del envío).
            Opcionales: <b>Concepto</b> (si no viene se pone "Costo de envío") y <b>Guia</b>. Cada gasto se carga a la
            nota de venta de ese pedido como gasto directo; si el pedido tiene varias notas se reparte entre ellas por su
            venta. Si un renglón ya se había cargado, se omite.{" "}
            <Button size="sm" color="link" style={{ padding: 0 }} onClick={descargarPlantillaGastos}>
              Descargar plantilla
            </Button>
          </p>
          <Input
            type="file"
            accept=".xlsx,.xls,.csv"
            disabled={gxTrabajando}
            onChange={(e) => {
              leerExcelGastos(e.target.files?.[0]);
              e.target.value = "";
            }}
          />
          {gxTrabajando ? <p className="mt-2">Procesando…</p> : null}
          {gxResultado ? (
            <>
              <p className="mt-3" style={{ fontSize: 14 }}>
                <b>{gxArchivo}</b> · {gxResultado.resumen.total} renglones:{" "}
                {gxResultado.aplicado ? (
                  <span style={{ color: "#28a745" }}>{gxResultado.resumen.cargados} cargados</span>
                ) : (
                  <span style={{ color: "#28a745" }}>{gxResultado.resumen.ok} listos para cargar</span>
                )}{" "}
                · <span style={{ color: "#6c757d" }}>{gxResultado.resumen.omitidos} omitidos</span> ·{" "}
                <span style={{ color: "#dc3545" }}>{gxResultado.resumen.errores} con error</span> · importe{" "}
                <b>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(gxResultado.resumen.importe)}</b>
              </p>
              <Table size="sm" bordered className="table-responsive-xl" style={{ fontSize: 13 }}>
                <thead>
                  <tr>
                    <th>Fila</th>
                    <th>Pedido</th>
                    <th>Cliente</th>
                    <th>Nota(s)</th>
                    <th>Concepto</th>
                    <th>Guía</th>
                    <th align="right">Importe</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {gxResultado.filas.map((f) => {
                    const color =
                      f.estado === "error" ? "#f8d7da" : f.estado === "omitido" ? "#e9ecef" : f.estado === "cargado" ? "#d4edda" : undefined;
                    const etiqueta =
                      f.estado === "ok" ? "Listo" : f.estado === "cargado" ? "Cargado" : f.estado === "omitido" ? "Omitido" : "Error";
                    return (
                      <tr key={f.renglon} style={{ backgroundColor: color }}>
                        <td>{f.renglon}</td>
                        <td>{String(f.pedido)}</td>
                        <td>{f.cliente || ""}</td>
                        <td>
                          {(f.notas || []).map((n) => (
                            <div key={n.idSurtido}>
                              #{n.idSurtido} · {fDMA(n.fecha)}
                              {(f.notas || []).length > 1
                                ? ` · ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n.monto)}`
                                : ""}
                            </div>
                          ))}
                        </td>
                        <td>{f.concepto}</td>
                        <td>{f.referencia}</td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(f.importe || 0)}
                        </td>
                        <td>
                          <b>{etiqueta}</b>
                          {f.mensaje ? <div style={{ fontSize: 12 }}>{f.mensaje}</div> : null}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" disabled={gxTrabajando} onClick={() => setModalGastosExcel(false)}>
            Cerrar
          </Button>
          {gxResultado && !gxResultado.aplicado ? (
            <Button color="success" disabled={gxTrabajando || !gxResultado.resumen.ok} onClick={aplicarGastosExcel}>
              Cargar {gxResultado.resumen.ok} gasto{gxResultado.resumen.ok === 1 ? "" : "s"}
            </Button>
          ) : null}
        </ModalFooter>
      </Modal>

      {/* Gastos directos de la venta */}
      <Modal size="lg" isOpen={modalGastos} toggle={() => setModalGastos(!modalGastos)}>
        <ModalHeader toggle={() => setModalGastos(!modalGastos)}>
          <h4>
            Gastos directos — Nota {notaGastos?.numero} · {notaGastos?.clientes}
          </h4>
        </ModalHeader>
        <ModalBody>
          <p style={{ fontSize: 13, color: "#666" }}>
            Gastos que se le atribuyen a ESTA venta (flete pagado aparte,
            maniobras, empaque especial). El Reporte de Utilidades los descuenta
            de la utilidad de la nota.
          </p>
          <Table size="sm" striped borderless>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Concepto</th>
                <th align="right">Importe</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {gastosNota.map((g) => (
                <tr key={g._id}>
                  <td>{fDMA(g.fecha)}</td>
                  <td>{g.concepto}</td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(g.importe)}
                  </td>
                  <td>
                    <Button size="sm" color="danger" onClick={() => cancelarGasto(g._id)}>
                      <i className="fas fa-times"></i>
                    </Button>
                  </td>
                </tr>
              ))}
              <tr>
                <td>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={gastoFecha}
                    onChange={(e) => setGastoFecha(e.target.value)}
                  />
                </td>
                <td>
                  <Input
                    bsSize="sm"
                    type="text"
                    placeholder="Concepto"
                    value={gastoConcepto}
                    onChange={(e) => setGastoConcepto(e.target.value)}
                  />
                </td>
                <td>
                  <Input
                    bsSize="sm"
                    type="number"
                    min="0"
                    step="any"
                    placeholder="0.00"
                    value={gastoImporte}
                    onChange={(e) => setGastoImporte(e.target.value)}
                  />
                </td>
                <td>
                  <Button size="sm" color="success" onClick={guardarGasto}>
                    <i className="fas fa-plus"></i>
                  </Button>
                </td>
              </tr>
              <tr style={{ borderTop: "2px solid #333", fontWeight: "bold" }}>
                <td colSpan={2} align="right">TOTAL</td>
                <td align="right">
                  {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalGastosNota)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="secondary" onClick={() => setModalGastos(false)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Visor de la nota: se ve sin bajarla, y desde aquí se puede descargar */}
      <Modal size="lg" isOpen={!!notaPreview} toggle={cerrarPreview}>
        <ModalHeader toggle={cerrarPreview}>
          <h4>Nota {notaPreview?.numero}</h4>
        </ModalHeader>
        <ModalBody style={{ padding: 0 }}>
          {notaPreview?.url ? (
            <iframe
              title={`Nota ${notaPreview.numero}`}
              src={notaPreview.url}
              style={{ width: "100%", height: "70vh", border: 0 }}
            />
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            color="danger"
            href={notaPreview?.url}
            download={`Nota-${notaPreview?.numero}.pdf`}
          >
            Descargar <i className="far fa-file-pdf"></i>
          </Button>
          <Button size="sm" color="secondary" onClick={cerrarPreview}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoVentas;
